webpackJsonp([1],{

/***/ 242:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _App = __webpack_require__(243);

var _App2 = _interopRequireDefault(_App);

var _awsSuite = __webpack_require__(249);

var _awsSuite2 = _interopRequireDefault(_awsSuite);

var _bootstrapVue = __webpack_require__(327);

var _bootstrapVue2 = _interopRequireDefault(_bootstrapVue);

var _router = __webpack_require__(328);

var _router2 = _interopRequireDefault(_router);

var _vue = __webpack_require__(41);

var _vue2 = _interopRequireDefault(_vue);

var _vuejsDialog = __webpack_require__(490);

var _vuejsDialog2 = _interopRequireDefault(_vuejsDialog);

var _vuejsLogger = __webpack_require__(491);

var _vuejsLogger2 = _interopRequireDefault(_vuejsLogger);

var _vueJsModal = __webpack_require__(495);

var _vueJsModal2 = _interopRequireDefault(_vueJsModal);

var _vueMoment = __webpack_require__(496);

var _vueMoment2 = _interopRequireDefault(_vueMoment);

var _vueNotification = __webpack_require__(498);

var _vueNotification2 = _interopRequireDefault(_vueNotification);

var _vueResource = __webpack_require__(499);

var _vueResource2 = _interopRequireDefault(_vueResource);

var _vueGoodTable = __webpack_require__(501);

var _vueGoodTable2 = _interopRequireDefault(_vueGoodTable);

var _veeValidate = __webpack_require__(502);

var _veeValidate2 = _interopRequireDefault(_veeValidate);

var _vueNativeNotification = __webpack_require__(503);

var _vueNativeNotification2 = _interopRequireDefault(_vueNativeNotification);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

_vue2.default.config.productionTip = false;

_vue2.default.use(_vueJsModal2.default);
_vue2.default.use(_vuejsDialog2.default);
_vue2.default.use(_vueGoodTable2.default);
_vue2.default.use(_vueMoment2.default);
_vue2.default.use(_vueNotification2.default);
_vue2.default.use(_vueNativeNotification2.default, { requestOnNotify: true });
_vue2.default.use(_vueResource2.default);
_vue2.default.use(_bootstrapVue2.default);
_vue2.default.use(_vuejsLogger2.default, { logLevel: 'debug' });
_vue2.default.use(_awsSuite2.default, {
  clientId: '281589362472-i3fmfnuuet0it2bah3vo9deqro8oltmq.apps.googleusercontent.com',
  identityPoolId: 'us-east-1:2278b4c1-8c54-4b64-96a0-e1a62db74733'
});
_vue2.default.use(_veeValidate2.default);

new _vue2.default({
  el: '#app',
  router: _router2.default,
  template: '<App/>',
  components: {
    App: _App2.default
  }
});

/***/ }),

/***/ 243:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_App_vue__ = __webpack_require__(247);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_App_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_App_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_35407236_hasScoped_false_node_modules_vue_loader_lib_selector_type_template_index_0_App_vue__ = __webpack_require__(248);
function injectStyle (ssrContext) {
  __webpack_require__(244)
  __webpack_require__(246)
}
var normalizeComponent = __webpack_require__(2)
/* script */

/* template */

/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_App_vue___default.a,
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_35407236_hasScoped_false_node_modules_vue_loader_lib_selector_type_template_index_0_App_vue__["a" /* default */],
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),

/***/ 244:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 246:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 247:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = {
  name: 'app',
  mounted: function mounted() {
    this.$log.debug('App mounted');
  }
};

/***/ }),

/***/ 248:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('router-view'),_vm._v(" "),_c('notifications')],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ 249:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _defineProperties = __webpack_require__(250);

var _defineProperties2 = _interopRequireDefault(_defineProperties);

var _classCallCheck2 = __webpack_require__(53);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(54);

var _createClass3 = _interopRequireDefault(_createClass2);

var _global = __webpack_require__(76);

var _global2 = _interopRequireDefault(_global);

var _vueGoogleAuth = __webpack_require__(326);

var _vueGoogleAuth2 = _interopRequireDefault(_vueGoogleAuth);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var AWSSuite = function () {
  function AWSSuite(Vue, options) {
    var _this = this;

    (0, _classCallCheck3.default)(this, AWSSuite);

    var authOptions = {
      client_id: options.clientId
    };

    Object.defineProperty(authOptions, 'scope', {
      'get': function get() {
        return 'profile email https://www.googleapis.com/auth/plus.login https://www.googleapis.com/auth/drive.readonly';
      },
      'set': function set() {}
    });

    Vue.use(_vueGoogleAuth2.default, authOptions);

    this._googleAuth = Vue.googleAuth();
    this._app = Vue;
    this._options = options;
    this._listeners = [function (authenticated) {
      Vue.$log.debug('Authentication changed to', authenticated);
    }];

    _global2.default.config.credentials = new _global2.default.CognitoIdentityCredentials({
      IdentityPoolId: options.identityPoolId,
      Logins: { 'accounts.google.com': localStorage.getItem('$auth.token') }
    }, {
      region: 'us-east-1'
    });

    this._googleAuth.directAccess();

    this._googleAuth.load().then(function () {
      var auth = window.gapi.auth2.getAuthInstance();

      auth.then(function () {
        if (auth.isSignedIn.get()) {
          _this._refresh();
        }

        auth.isSignedIn.listen(function (signedIn) {
          if (!signedIn) {
            _this.signOut();
          }
        });
      });
    });
  }

  (0, _createClass3.default)(AWSSuite, [{
    key: 'signedIn',
    value: function signedIn() {
      this._app.$log.debug('Sign in check', localStorage.getItem('$auth.token') ? 'success' : 'fail');

      return localStorage.getItem('$auth.token');
    }
  }, {
    key: 'signIn',
    value: function signIn(callback) {
      var _this2 = this;

      if (this.signedIn()) {
        callback();
      } else {
        this._googleAuth.signIn(function (code) {
          localStorage.setItem('$auth.token', code.getAuthResponse().id_token);
          _this2._refresh();
          callback();
        }, function (error) {
          callback(error);
        });
      }
    }
  }, {
    key: 'onChange',
    value: function onChange(callback) {
      this._listeners.push(callback);
    }
  }, {
    key: 'signOut',
    value: function signOut() {
      localStorage.removeItem('$auth.token');

      this._listeners.forEach(function (listener) {
        return listener(false);
      });
    }
  }, {
    key: '_refresh',
    value: function _refresh() {
      var _this3 = this;

      _global2.default.config.credentials.params.Logins['accounts.google.com'] = localStorage.getItem('$auth.token');

      _global2.default.config.credentials.get(function () {
        if (_global2.default.config.credentials.expired) {
          _this3.signOut();
        } else {
          _this3._listeners.forEach(function (listener) {
            return listener(true);
          });
        }
      });
    }
  }]);
  return AWSSuite;
}();

function plugin(Vue, options) {
  if (!plugin.installed) {
    plugin.installed = true;

    var instance = null;

    (0, _defineProperties2.default)(Vue.prototype, {
      $auth: {
        get: function get() {
          if (!instance) {
            instance = new AWSSuite(Vue, options);
          }

          return instance;
        }
      }
    });
  }
}

exports.default = plugin;

/***/ }),

/***/ 271:
/***/ (function(module, exports) {

module.exports = {"rules":{"*/*":{"endpoint":"{service}.{region}.amazonaws.com"},"cn-*/*":{"endpoint":"{service}.{region}.amazonaws.com.cn"},"us-iso-*/*":{"endpoint":"{service}.{region}.c2s.ic.gov"},"us-isob-*/*":{"endpoint":"{service}.{region}.sc2s.sgov.gov"},"*/budgets":"globalSSL","*/cloudfront":"globalSSL","*/iam":"globalSSL","*/sts":"globalSSL","*/importexport":{"endpoint":"{service}.amazonaws.com","signatureVersion":"v2","globalEndpoint":true},"*/route53":{"endpoint":"https://{service}.amazonaws.com","signatureVersion":"v3https","globalEndpoint":true},"*/waf":"globalSSL","us-gov-*/iam":"globalGovCloud","us-gov-*/sts":{"endpoint":"{service}.{region}.amazonaws.com"},"us-gov-west-1/s3":"s3signature","us-west-1/s3":"s3signature","us-west-2/s3":"s3signature","eu-west-1/s3":"s3signature","ap-southeast-1/s3":"s3signature","ap-southeast-2/s3":"s3signature","ap-northeast-1/s3":"s3signature","sa-east-1/s3":"s3signature","us-east-1/s3":{"endpoint":"{service}.amazonaws.com","signatureVersion":"s3"},"us-east-1/sdb":{"endpoint":"{service}.amazonaws.com","signatureVersion":"v2"},"*/sdb":{"endpoint":"{service}.{region}.amazonaws.com","signatureVersion":"v2"}},"patterns":{"globalSSL":{"endpoint":"https://{service}.amazonaws.com","globalEndpoint":true},"globalGovCloud":{"endpoint":"{service}.us-gov.amazonaws.com"},"s3signature":{"endpoint":"{service}.{region}.amazonaws.com","signatureVersion":"s3"}}}

/***/ }),

/***/ 314:
/***/ (function(module, exports) {

module.exports = {"version":"2.0","metadata":{"apiVersion":"2011-06-15","endpointPrefix":"sts","globalEndpoint":"sts.amazonaws.com","protocol":"query","serviceAbbreviation":"AWS STS","serviceFullName":"AWS Security Token Service","serviceId":"STS","signatureVersion":"v4","uid":"sts-2011-06-15","xmlNamespace":"https://sts.amazonaws.com/doc/2011-06-15/"},"operations":{"AssumeRole":{"input":{"type":"structure","required":["RoleArn","RoleSessionName"],"members":{"RoleArn":{},"RoleSessionName":{},"PolicyArns":{"shape":"S4"},"Policy":{},"DurationSeconds":{"type":"integer"},"Tags":{"shape":"S8"},"TransitiveTagKeys":{"type":"list","member":{}},"ExternalId":{},"SerialNumber":{},"TokenCode":{}}},"output":{"resultWrapper":"AssumeRoleResult","type":"structure","members":{"Credentials":{"shape":"Sh"},"AssumedRoleUser":{"shape":"Sm"},"PackedPolicySize":{"type":"integer"}}}},"AssumeRoleWithSAML":{"input":{"type":"structure","required":["RoleArn","PrincipalArn","SAMLAssertion"],"members":{"RoleArn":{},"PrincipalArn":{},"SAMLAssertion":{},"PolicyArns":{"shape":"S4"},"Policy":{},"DurationSeconds":{"type":"integer"}}},"output":{"resultWrapper":"AssumeRoleWithSAMLResult","type":"structure","members":{"Credentials":{"shape":"Sh"},"AssumedRoleUser":{"shape":"Sm"},"PackedPolicySize":{"type":"integer"},"Subject":{},"SubjectType":{},"Issuer":{},"Audience":{},"NameQualifier":{}}}},"AssumeRoleWithWebIdentity":{"input":{"type":"structure","required":["RoleArn","RoleSessionName","WebIdentityToken"],"members":{"RoleArn":{},"RoleSessionName":{},"WebIdentityToken":{},"ProviderId":{},"PolicyArns":{"shape":"S4"},"Policy":{},"DurationSeconds":{"type":"integer"}}},"output":{"resultWrapper":"AssumeRoleWithWebIdentityResult","type":"structure","members":{"Credentials":{"shape":"Sh"},"SubjectFromWebIdentityToken":{},"AssumedRoleUser":{"shape":"Sm"},"PackedPolicySize":{"type":"integer"},"Provider":{},"Audience":{}}}},"DecodeAuthorizationMessage":{"input":{"type":"structure","required":["EncodedMessage"],"members":{"EncodedMessage":{}}},"output":{"resultWrapper":"DecodeAuthorizationMessageResult","type":"structure","members":{"DecodedMessage":{}}}},"GetAccessKeyInfo":{"input":{"type":"structure","required":["AccessKeyId"],"members":{"AccessKeyId":{}}},"output":{"resultWrapper":"GetAccessKeyInfoResult","type":"structure","members":{"Account":{}}}},"GetCallerIdentity":{"input":{"type":"structure","members":{}},"output":{"resultWrapper":"GetCallerIdentityResult","type":"structure","members":{"UserId":{},"Account":{},"Arn":{}}}},"GetFederationToken":{"input":{"type":"structure","required":["Name"],"members":{"Name":{},"Policy":{},"PolicyArns":{"shape":"S4"},"DurationSeconds":{"type":"integer"},"Tags":{"shape":"S8"}}},"output":{"resultWrapper":"GetFederationTokenResult","type":"structure","members":{"Credentials":{"shape":"Sh"},"FederatedUser":{"type":"structure","required":["FederatedUserId","Arn"],"members":{"FederatedUserId":{},"Arn":{}}},"PackedPolicySize":{"type":"integer"}}}},"GetSessionToken":{"input":{"type":"structure","members":{"DurationSeconds":{"type":"integer"},"SerialNumber":{},"TokenCode":{}}},"output":{"resultWrapper":"GetSessionTokenResult","type":"structure","members":{"Credentials":{"shape":"Sh"}}}}},"shapes":{"S4":{"type":"list","member":{"type":"structure","members":{"arn":{}}}},"S8":{"type":"list","member":{"type":"structure","required":["Key","Value"],"members":{"Key":{},"Value":{}}}},"Sh":{"type":"structure","required":["AccessKeyId","SecretAccessKey","SessionToken","Expiration"],"members":{"AccessKeyId":{},"SecretAccessKey":{},"SessionToken":{},"Expiration":{"type":"timestamp"}}},"Sm":{"type":"structure","required":["AssumedRoleId","Arn"],"members":{"AssumedRoleId":{},"Arn":{}}}}}

/***/ }),

/***/ 315:
/***/ (function(module, exports) {

module.exports = {"pagination":{}}

/***/ }),

/***/ 321:
/***/ (function(module, exports) {

module.exports = {"version":"2.0","metadata":{"apiVersion":"2014-06-30","endpointPrefix":"cognito-identity","jsonVersion":"1.1","protocol":"json","serviceFullName":"Amazon Cognito Identity","serviceId":"Cognito Identity","signatureVersion":"v4","targetPrefix":"AWSCognitoIdentityService","uid":"cognito-identity-2014-06-30"},"operations":{"CreateIdentityPool":{"input":{"type":"structure","required":["IdentityPoolName","AllowUnauthenticatedIdentities"],"members":{"IdentityPoolName":{},"AllowUnauthenticatedIdentities":{"type":"boolean"},"AllowClassicFlow":{"type":"boolean"},"SupportedLoginProviders":{"shape":"S5"},"DeveloperProviderName":{},"OpenIdConnectProviderARNs":{"shape":"S9"},"CognitoIdentityProviders":{"shape":"Sb"},"SamlProviderARNs":{"shape":"Sg"},"IdentityPoolTags":{"shape":"Sh"}}},"output":{"shape":"Sk"}},"DeleteIdentities":{"input":{"type":"structure","required":["IdentityIdsToDelete"],"members":{"IdentityIdsToDelete":{"type":"list","member":{}}}},"output":{"type":"structure","members":{"UnprocessedIdentityIds":{"type":"list","member":{"type":"structure","members":{"IdentityId":{},"ErrorCode":{}}}}}}},"DeleteIdentityPool":{"input":{"type":"structure","required":["IdentityPoolId"],"members":{"IdentityPoolId":{}}}},"DescribeIdentity":{"input":{"type":"structure","required":["IdentityId"],"members":{"IdentityId":{}}},"output":{"shape":"Sv"}},"DescribeIdentityPool":{"input":{"type":"structure","required":["IdentityPoolId"],"members":{"IdentityPoolId":{}}},"output":{"shape":"Sk"}},"GetCredentialsForIdentity":{"input":{"type":"structure","required":["IdentityId"],"members":{"IdentityId":{},"Logins":{"shape":"S10"},"CustomRoleArn":{}}},"output":{"type":"structure","members":{"IdentityId":{},"Credentials":{"type":"structure","members":{"AccessKeyId":{},"SecretKey":{},"SessionToken":{},"Expiration":{"type":"timestamp"}}}}}},"GetId":{"input":{"type":"structure","required":["IdentityPoolId"],"members":{"AccountId":{},"IdentityPoolId":{},"Logins":{"shape":"S10"}}},"output":{"type":"structure","members":{"IdentityId":{}}}},"GetIdentityPoolRoles":{"input":{"type":"structure","required":["IdentityPoolId"],"members":{"IdentityPoolId":{}}},"output":{"type":"structure","members":{"IdentityPoolId":{},"Roles":{"shape":"S1c"},"RoleMappings":{"shape":"S1e"}}}},"GetOpenIdToken":{"input":{"type":"structure","required":["IdentityId"],"members":{"IdentityId":{},"Logins":{"shape":"S10"}}},"output":{"type":"structure","members":{"IdentityId":{},"Token":{}}}},"GetOpenIdTokenForDeveloperIdentity":{"input":{"type":"structure","required":["IdentityPoolId","Logins"],"members":{"IdentityPoolId":{},"IdentityId":{},"Logins":{"shape":"S10"},"TokenDuration":{"type":"long"}}},"output":{"type":"structure","members":{"IdentityId":{},"Token":{}}}},"ListIdentities":{"input":{"type":"structure","required":["IdentityPoolId","MaxResults"],"members":{"IdentityPoolId":{},"MaxResults":{"type":"integer"},"NextToken":{},"HideDisabled":{"type":"boolean"}}},"output":{"type":"structure","members":{"IdentityPoolId":{},"Identities":{"type":"list","member":{"shape":"Sv"}},"NextToken":{}}}},"ListIdentityPools":{"input":{"type":"structure","required":["MaxResults"],"members":{"MaxResults":{"type":"integer"},"NextToken":{}}},"output":{"type":"structure","members":{"IdentityPools":{"type":"list","member":{"type":"structure","members":{"IdentityPoolId":{},"IdentityPoolName":{}}}},"NextToken":{}}}},"ListTagsForResource":{"input":{"type":"structure","required":["ResourceArn"],"members":{"ResourceArn":{}}},"output":{"type":"structure","members":{"Tags":{"shape":"Sh"}}}},"LookupDeveloperIdentity":{"input":{"type":"structure","required":["IdentityPoolId"],"members":{"IdentityPoolId":{},"IdentityId":{},"DeveloperUserIdentifier":{},"MaxResults":{"type":"integer"},"NextToken":{}}},"output":{"type":"structure","members":{"IdentityId":{},"DeveloperUserIdentifierList":{"type":"list","member":{}},"NextToken":{}}}},"MergeDeveloperIdentities":{"input":{"type":"structure","required":["SourceUserIdentifier","DestinationUserIdentifier","DeveloperProviderName","IdentityPoolId"],"members":{"SourceUserIdentifier":{},"DestinationUserIdentifier":{},"DeveloperProviderName":{},"IdentityPoolId":{}}},"output":{"type":"structure","members":{"IdentityId":{}}}},"SetIdentityPoolRoles":{"input":{"type":"structure","required":["IdentityPoolId","Roles"],"members":{"IdentityPoolId":{},"Roles":{"shape":"S1c"},"RoleMappings":{"shape":"S1e"}}}},"TagResource":{"input":{"type":"structure","required":["ResourceArn","Tags"],"members":{"ResourceArn":{},"Tags":{"shape":"Sh"}}},"output":{"type":"structure","members":{}}},"UnlinkDeveloperIdentity":{"input":{"type":"structure","required":["IdentityId","IdentityPoolId","DeveloperProviderName","DeveloperUserIdentifier"],"members":{"IdentityId":{},"IdentityPoolId":{},"DeveloperProviderName":{},"DeveloperUserIdentifier":{}}}},"UnlinkIdentity":{"input":{"type":"structure","required":["IdentityId","Logins","LoginsToRemove"],"members":{"IdentityId":{},"Logins":{"shape":"S10"},"LoginsToRemove":{"shape":"Sw"}}}},"UntagResource":{"input":{"type":"structure","required":["ResourceArn","TagKeys"],"members":{"ResourceArn":{},"TagKeys":{"type":"list","member":{}}}},"output":{"type":"structure","members":{}}},"UpdateIdentityPool":{"input":{"shape":"Sk"},"output":{"shape":"Sk"}}},"shapes":{"S5":{"type":"map","key":{},"value":{}},"S9":{"type":"list","member":{}},"Sb":{"type":"list","member":{"type":"structure","members":{"ProviderName":{},"ClientId":{},"ServerSideTokenCheck":{"type":"boolean"}}}},"Sg":{"type":"list","member":{}},"Sh":{"type":"map","key":{},"value":{}},"Sk":{"type":"structure","required":["IdentityPoolId","IdentityPoolName","AllowUnauthenticatedIdentities"],"members":{"IdentityPoolId":{},"IdentityPoolName":{},"AllowUnauthenticatedIdentities":{"type":"boolean"},"AllowClassicFlow":{"type":"boolean"},"SupportedLoginProviders":{"shape":"S5"},"DeveloperProviderName":{},"OpenIdConnectProviderARNs":{"shape":"S9"},"CognitoIdentityProviders":{"shape":"Sb"},"SamlProviderARNs":{"shape":"Sg"},"IdentityPoolTags":{"shape":"Sh"}}},"Sv":{"type":"structure","members":{"IdentityId":{},"Logins":{"shape":"Sw"},"CreationDate":{"type":"timestamp"},"LastModifiedDate":{"type":"timestamp"}}},"Sw":{"type":"list","member":{}},"S10":{"type":"map","key":{},"value":{}},"S1c":{"type":"map","key":{},"value":{}},"S1e":{"type":"map","key":{},"value":{"type":"structure","required":["Type"],"members":{"Type":{},"AmbiguousRoleResolution":{},"RulesConfiguration":{"type":"structure","required":["Rules"],"members":{"Rules":{"type":"list","member":{"type":"structure","required":["Claim","MatchType","Value","RoleARN"],"members":{"Claim":{},"MatchType":{},"Value":{},"RoleARN":{}}}}}}}}}}}

/***/ }),

/***/ 322:
/***/ (function(module, exports) {

module.exports = {"pagination":{}}

/***/ }),

/***/ 328:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _vue = __webpack_require__(41);

var _vue2 = _interopRequireDefault(_vue);

var _vueRouter = __webpack_require__(329);

var _vueRouter2 = _interopRequireDefault(_vueRouter);

var _Full = __webpack_require__(330);

var _Full2 = _interopRequireDefault(_Full);

var _Limited = __webpack_require__(387);

var _Limited2 = _interopRequireDefault(_Limited);

var _PresenceManagement = __webpack_require__(391);

var _PresenceManagement2 = _interopRequireDefault(_PresenceManagement);

var _RecurringJobs = __webpack_require__(475);

var _RecurringJobs2 = _interopRequireDefault(_RecurringJobs);

var _JobLog = __webpack_require__(482);

var _JobLog2 = _interopRequireDefault(_JobLog);

var _Login = __webpack_require__(486);

var _Login2 = _interopRequireDefault(_Login);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

_vue2.default.use(_vueRouter2.default);

var router = new _vueRouter2.default({
  mode: 'history',
  linkActiveClass: 'open active',
  scrollBehavior: function scrollBehavior() {
    return { y: 0 };
  },
  routes: [{
    path: '/',
    redirect: '/recurring',
    name: 'Welcome',
    component: _Limited2.default,
    children: [{
      path: 'login',
      name: 'Login',
      component: _Login2.default,
      meta: { auth: false }
    }]
  }, {
    path: '/',
    redirect: '/recurring',
    name: 'Home',
    component: _Full2.default,
    children: [{
      path: 'recurring',
      name: 'Recurring Jobs',
      component: _RecurringJobs2.default,
      children: [{
        path: ':jobId',
        name: 'Job Log',
        component: _JobLog2.default
      }]
    }, {
      path: 'presence-management',
      name: 'Presence Management',
      component: _PresenceManagement2.default,
      children: [{
        path: ':jobId',
        name: 'Job Report',
        component: _JobLog2.default
      }]
    }]
  }]
});

router.onReady(function () {
  router.app.$log.debug('Router ready');

  router.app.$auth.onChange(function (authenticated) {
    if (!authenticated) {
      router.push({ name: 'Login' });
    }
  });
});

router.beforeEach(function (to, from, next) {
  if (router.app.$auth.signedIn() || to.meta && to.meta.auth === false) {
    router.app.$log.debug(to.path, 'authorized');
    next();
  } else {
    router.app.$log.debug(to.path, 'not authorized');
    next({
      path: '/login'
    });
  }
});

exports.default = router;

/***/ }),

/***/ 330:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Full_vue__ = __webpack_require__(331);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Full_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Full_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_b98f647e_hasScoped_false_node_modules_vue_loader_lib_selector_type_template_index_0_Full_vue__ = __webpack_require__(386);
var normalizeComponent = __webpack_require__(2)
/* script */

/* template */

/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Full_vue___default.a,
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_b98f647e_hasScoped_false_node_modules_vue_loader_lib_selector_type_template_index_0_Full_vue__["a" /* default */],
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),

/***/ 331:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _nav = __webpack_require__(97);

var _nav2 = _interopRequireDefault(_nav);

var _components = __webpack_require__(98);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
  name: 'full',
  components: {
    AppHeader: _components.Header,
    Sidebar: _components.Sidebar,

    AppFooter: _components.Footer,
    Breadcrumb: _components.Breadcrumb
  },
  data: function data() {
    return {
      nav: _nav2.default.items
    };
  },

  computed: {
    name: function name() {
      return this.$route.name;
    },
    list: function list() {
      return this.$route.matched;
    }
  }
};

/***/ }),

/***/ 332:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Aside_vue__ = __webpack_require__(333);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Aside_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Aside_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_12fbde0c_hasScoped_false_node_modules_vue_loader_lib_selector_type_template_index_0_Aside_vue__ = __webpack_require__(334);
var normalizeComponent = __webpack_require__(2)
/* script */

/* template */

/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Aside_vue___default.a,
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_12fbde0c_hasScoped_false_node_modules_vue_loader_lib_selector_type_template_index_0_Aside_vue__["a" /* default */],
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),

/***/ 333:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = {
  name: 'aside'
};

/***/ }),

/***/ 334:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('aside',{staticClass:"aside-menu"})}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ 335:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Breadcrumb_vue__ = __webpack_require__(336);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Breadcrumb_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Breadcrumb_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_0a48de31_hasScoped_false_node_modules_vue_loader_lib_selector_type_template_index_0_Breadcrumb_vue__ = __webpack_require__(337);
var normalizeComponent = __webpack_require__(2)
/* script */

/* template */

/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Breadcrumb_vue___default.a,
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_0a48de31_hasScoped_false_node_modules_vue_loader_lib_selector_type_template_index_0_Breadcrumb_vue__["a" /* default */],
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),

/***/ 336:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = {
  props: {
    list: {
      type: Array,
      required: true,
      default: function _default() {
        return [];
      }
    }
  },
  methods: {
    isLast: function isLast(index) {
      return index === this.list.length - 1;
    },
    showName: function showName(item) {
      if (item.meta && item.meta.label) {
        item = item.meta && item.meta.label;
      }
      if (item.name) {
        item = item.name;
      }
      return item;
    }
  }
};

/***/ }),

/***/ 337:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('ol',{staticClass:"breadcrumb"},_vm._l((_vm.list),function(item,index){return _c('li',{staticClass:"breadcrumb-item"},[(_vm.isLast(index))?_c('span',{staticClass:"active"},[_vm._v(_vm._s(_vm.showName(item)))]):_c('router-link',{attrs:{"to":item.path}},[_vm._v(_vm._s(_vm.showName(item)))])],1)}))}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ 338:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Callout_vue__ = __webpack_require__(339);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Callout_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Callout_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_3ebbc51c_hasScoped_false_node_modules_vue_loader_lib_selector_type_template_index_0_Callout_vue__ = __webpack_require__(340);
var normalizeComponent = __webpack_require__(2)
/* script */

/* template */

/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Callout_vue___default.a,
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_3ebbc51c_hasScoped_false_node_modules_vue_loader_lib_selector_type_template_index_0_Callout_vue__["a" /* default */],
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),

/***/ 339:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = {
  props: {
    variant: {
      type: String
    }
  },
  computed: {
    classList: function classList() {
      return ['callout', this.calloutVariant];
    },
    calloutVariant: function calloutVariant() {
      return this.variant ? 'callout-' + this.variant : '';
    }
  }
};

/***/ }),

/***/ 340:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:_vm.classList},[_vm._t("default")],2)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ 341:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Footer_vue__ = __webpack_require__(342);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Footer_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Footer_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_0f65d2c9_hasScoped_false_node_modules_vue_loader_lib_selector_type_template_index_0_Footer_vue__ = __webpack_require__(343);
var normalizeComponent = __webpack_require__(2)
/* script */

/* template */

/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Footer_vue___default.a,
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_0f65d2c9_hasScoped_false_node_modules_vue_loader_lib_selector_type_template_index_0_Footer_vue__["a" /* default */],
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),

/***/ 342:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = {
  name: 'footer'
};

/***/ }),

/***/ 343:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _vm._m(0)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('footer',{staticClass:"app-footer"},[_c('a',{attrs:{"href":"http://jockey.getlocal.co"}},[_vm._v("Jockey")]),_vm._v(" © 2017 GPO\n  "),_c('span',{staticClass:"float-right"},[_vm._v("Powered by "),_c('a',{attrs:{"href":"http://getlocal.co"}},[_vm._v("GetLocal")])])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ 344:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Header_vue__ = __webpack_require__(346);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Header_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Header_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_309836bb_hasScoped_false_node_modules_vue_loader_lib_selector_type_template_index_0_Header_vue__ = __webpack_require__(347);
function injectStyle (ssrContext) {
  __webpack_require__(345)
}
var normalizeComponent = __webpack_require__(2)
/* script */

/* template */

/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Header_vue___default.a,
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_309836bb_hasScoped_false_node_modules_vue_loader_lib_selector_type_template_index_0_Header_vue__["a" /* default */],
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),

/***/ 345:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 346:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = {
  name: 'header',
  methods: {
    signOut: function signOut(e) {
      e.preventDefault();
      this.$auth.signOut();
    },
    sidebarToggle: function sidebarToggle(e) {
      e.preventDefault();
      document.body.classList.toggle('sidebar-hidden');
    },
    sidebarMinimize: function sidebarMinimize(e) {
      e.preventDefault();
      document.body.classList.toggle('sidebar-minimized');
    },
    mobileSidebarToggle: function mobileSidebarToggle(e) {
      e.preventDefault();
      document.body.classList.toggle('sidebar-mobile-show');
    },
    asideToggle: function asideToggle(e) {
      e.preventDefault();
      document.body.classList.toggle('aside-menu-hidden');
    }
  }
};

/***/ }),

/***/ 347:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('header',{staticClass:"app-header navbar"},[_c('button',{staticClass:"navbar-toggler mobile-sidebar-toggler d-lg-none",attrs:{"type":"button"},on:{"click":_vm.mobileSidebarToggle}},[_vm._v("☰")]),_vm._v(" "),_c('b-link',{staticClass:"navbar-brand",attrs:{"to":"#"}}),_vm._v(" "),_c('button',{staticClass:"navbar-toggler sidebar-toggler d-md-down-none mr-auto",attrs:{"type":"button"},on:{"click":_vm.sidebarToggle}},[_vm._v("☰")]),_vm._v(" "),_c('button',{staticClass:"btn btn-dark",attrs:{"type":"button"},on:{"click":_vm.signOut}},[_vm._v("Log Out")])],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ 348:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Sidebar_vue__ = __webpack_require__(350);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Sidebar_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Sidebar_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_f401fac4_hasScoped_false_node_modules_vue_loader_lib_selector_type_template_index_0_Sidebar_vue__ = __webpack_require__(382);
function injectStyle (ssrContext) {
  __webpack_require__(349)
}
var normalizeComponent = __webpack_require__(2)
/* script */

/* template */

/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Sidebar_vue___default.a,
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_f401fac4_hasScoped_false_node_modules_vue_loader_lib_selector_type_template_index_0_Sidebar_vue__["a" /* default */],
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),

/***/ 349:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 350:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _SidebarFooter = __webpack_require__(351);

var _SidebarFooter2 = _interopRequireDefault(_SidebarFooter);

var _SidebarForm = __webpack_require__(354);

var _SidebarForm2 = _interopRequireDefault(_SidebarForm);

var _SidebarHeader = __webpack_require__(357);

var _SidebarHeader2 = _interopRequireDefault(_SidebarHeader);

var _SidebarMinimizer = __webpack_require__(360);

var _SidebarMinimizer2 = _interopRequireDefault(_SidebarMinimizer);

var _SidebarNavDropdown = __webpack_require__(363);

var _SidebarNavDropdown2 = _interopRequireDefault(_SidebarNavDropdown);

var _SidebarNavLink = __webpack_require__(366);

var _SidebarNavLink2 = _interopRequireDefault(_SidebarNavLink);

var _SidebarNavTitle = __webpack_require__(370);

var _SidebarNavTitle2 = _interopRequireDefault(_SidebarNavTitle);

var _SidebarNavItem = __webpack_require__(379);

var _SidebarNavItem2 = _interopRequireDefault(_SidebarNavItem);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
  name: 'sidebar',
  props: {
    navItems: {
      type: Array,
      required: true,
      default: function _default() {
        return [];
      }
    }
  },
  components: {
    SidebarFooter: _SidebarFooter2.default,
    SidebarForm: _SidebarForm2.default,
    SidebarHeader: _SidebarHeader2.default,
    SidebarMinimizer: _SidebarMinimizer2.default,
    SidebarNavDropdown: _SidebarNavDropdown2.default,
    SidebarNavLink: _SidebarNavLink2.default,
    SidebarNavTitle: _SidebarNavTitle2.default,
    SidebarNavItem: _SidebarNavItem2.default
  },
  methods: {
    handleClick: function handleClick(e) {
      e.preventDefault();
      e.target.parentElement.classList.toggle('open');
    }
  }
};

/***/ }),

/***/ 351:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_SidebarFooter_vue__ = __webpack_require__(352);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_SidebarFooter_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_SidebarFooter_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_733eb259_hasScoped_false_node_modules_vue_loader_lib_selector_type_template_index_0_SidebarFooter_vue__ = __webpack_require__(353);
var normalizeComponent = __webpack_require__(2)
/* script */

/* template */

/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_SidebarFooter_vue___default.a,
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_733eb259_hasScoped_false_node_modules_vue_loader_lib_selector_type_template_index_0_SidebarFooter_vue__["a" /* default */],
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),

/***/ 352:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = {
  name: 'sidebar-footer'
};

/***/ }),

/***/ 353:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c("div")}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ 354:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_SidebarForm_vue__ = __webpack_require__(355);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_SidebarForm_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_SidebarForm_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_4ccc02fc_hasScoped_false_node_modules_vue_loader_lib_selector_type_template_index_0_SidebarForm_vue__ = __webpack_require__(356);
var normalizeComponent = __webpack_require__(2)
/* script */

/* template */

/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_SidebarForm_vue___default.a,
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_4ccc02fc_hasScoped_false_node_modules_vue_loader_lib_selector_type_template_index_0_SidebarForm_vue__["a" /* default */],
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),

/***/ 355:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = {
  name: 'sidebar-form'
};

/***/ }),

/***/ 356:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c("div")}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ 357:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_SidebarHeader_vue__ = __webpack_require__(358);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_SidebarHeader_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_SidebarHeader_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_d71dd36a_hasScoped_false_node_modules_vue_loader_lib_selector_type_template_index_0_SidebarHeader_vue__ = __webpack_require__(359);
var normalizeComponent = __webpack_require__(2)
/* script */

/* template */

/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_SidebarHeader_vue___default.a,
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_d71dd36a_hasScoped_false_node_modules_vue_loader_lib_selector_type_template_index_0_SidebarHeader_vue__["a" /* default */],
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),

/***/ 358:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = {
  name: 'sidebar-header'
};

/***/ }),

/***/ 359:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c("div")}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ 360:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_SidebarMinimizer_vue__ = __webpack_require__(361);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_SidebarMinimizer_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_SidebarMinimizer_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_02c1dcc6_hasScoped_false_node_modules_vue_loader_lib_selector_type_template_index_0_SidebarMinimizer_vue__ = __webpack_require__(362);
var normalizeComponent = __webpack_require__(2)
/* script */

/* template */

/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_SidebarMinimizer_vue___default.a,
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_02c1dcc6_hasScoped_false_node_modules_vue_loader_lib_selector_type_template_index_0_SidebarMinimizer_vue__["a" /* default */],
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),

/***/ 361:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = {
  name: 'sidebar-minimizer',
  methods: {
    sidebarMinimize: function sidebarMinimize() {
      document.body.classList.toggle('sidebar-minimized');
    },
    brandMinimize: function brandMinimize() {
      document.body.classList.toggle('brand-minimized');
    }
  }
};

/***/ }),

/***/ 362:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('button',{staticClass:"sidebar-minimizer",attrs:{"type":"button"},on:{"click":function($event){_vm.sidebarMinimize();_vm.brandMinimize()}}})}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ 363:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_SidebarNavDropdown_vue__ = __webpack_require__(364);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_SidebarNavDropdown_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_SidebarNavDropdown_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_49072f06_hasScoped_false_node_modules_vue_loader_lib_selector_type_template_index_0_SidebarNavDropdown_vue__ = __webpack_require__(365);
var normalizeComponent = __webpack_require__(2)
/* script */

/* template */

/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_SidebarNavDropdown_vue___default.a,
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_49072f06_hasScoped_false_node_modules_vue_loader_lib_selector_type_template_index_0_SidebarNavDropdown_vue__["a" /* default */],
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),

/***/ 364:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = {
  props: {
    name: {
      type: String,
      default: ''
    },
    url: {
      type: String,
      default: ''
    },
    icon: {
      type: String,
      default: ''
    }
  },
  methods: {
    handleClick: function handleClick(e) {
      e.preventDefault();
      e.target.parentElement.classList.toggle('open');
    }
  }
};

/***/ }),

/***/ 365:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('router-link',{staticClass:"nav-item nav-dropdown",attrs:{"tag":"li","to":_vm.url,"disabled":""}},[_c('div',{staticClass:"nav-link nav-dropdown-toggle",on:{"click":_vm.handleClick}},[_c('i',{class:_vm.icon}),_vm._v(" "+_vm._s(_vm.name))]),_vm._v(" "),_c('ul',{staticClass:"nav-dropdown-items"},[_vm._t("default")],2)])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ 366:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_SidebarNavLink_vue__ = __webpack_require__(367);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_SidebarNavLink_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_SidebarNavLink_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_3b2d1622_hasScoped_false_node_modules_vue_loader_lib_selector_type_template_index_0_SidebarNavLink_vue__ = __webpack_require__(369);
var normalizeComponent = __webpack_require__(2)
/* script */

/* template */

/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_SidebarNavLink_vue___default.a,
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_3b2d1622_hasScoped_false_node_modules_vue_loader_lib_selector_type_template_index_0_SidebarNavLink_vue__["a" /* default */],
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),

/***/ 367:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _isUrlExternal = __webpack_require__(368);

var _isUrlExternal2 = _interopRequireDefault(_isUrlExternal);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
  name: 'sidebar-nav-link',
  props: {
    name: {
      type: String,
      default: ''
    },
    url: {
      type: String,
      default: ''
    },
    icon: {
      type: String,
      default: ''
    },
    badge: {
      type: Object,
      default: function _default() {}
    },
    variant: {
      type: String,
      default: ''
    }
  },
  computed: {
    classList: function classList() {
      return ['nav-link', this.linkVariant];
    },
    linkVariant: function linkVariant() {
      return this.variant ? 'nav-link-' + this.variant : '';
    },
    linkExternal: function linkExternal() {
      return (0, _isUrlExternal2.default)(this.url);
    }
  }
};

/***/ }),

/***/ 369:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.linkExternal)?_c('div',[_c('a',{class:_vm.classList,attrs:{"href":_vm.url}},[_c('i',{class:_vm.icon}),_vm._v(" "+_vm._s(_vm.name)+"\n    "),(_vm.badge && _vm.badge.text)?_c('b-badge',{attrs:{"variant":_vm.badge.variant}},[_vm._v(_vm._s(_vm.badge.text))]):_vm._e()],1)]):_c('div',[_c('router-link',{class:_vm.classList,attrs:{"to":_vm.url}},[_c('i',{class:_vm.icon}),_vm._v(" "+_vm._s(_vm.name)+"\n    "),(_vm.badge && _vm.badge.text)?_c('b-badge',{attrs:{"variant":_vm.badge.variant}},[_vm._v(_vm._s(_vm.badge.text))]):_vm._e()],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ 370:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_SidebarNavTitle_vue__ = __webpack_require__(371);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_SidebarNavTitle_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_SidebarNavTitle_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_4ee93533_hasScoped_false_node_modules_vue_loader_lib_selector_type_template_index_0_SidebarNavTitle_vue__ = __webpack_require__(378);
var normalizeComponent = __webpack_require__(2)
/* script */

/* template */

/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_SidebarNavTitle_vue___default.a,
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_4ee93533_hasScoped_false_node_modules_vue_loader_lib_selector_type_template_index_0_SidebarNavTitle_vue__["a" /* default */],
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),

/***/ 371:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _toConsumableArray2 = __webpack_require__(99);

var _toConsumableArray3 = _interopRequireDefault(_toConsumableArray2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
  props: {
    name: {
      type: String,
      default: ''
    },
    classes: {
      type: String,
      default: ''
    },
    wrapper: {
      type: Object,
      default: function _default() {}
    }
  },
  computed: {
    classList: function classList() {
      return ['nav-title'].concat((0, _toConsumableArray3.default)(this.itemClasses));
    },
    itemClasses: function itemClasses() {
      return this.classes ? this.classes.split(' ') : '';
    }
  }
};

/***/ }),

/***/ 378:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('li',{class:_vm.classList},[(_vm.wrapper && _vm.wrapper.element)?[_c(_vm.wrapper.element,_vm._b({tag:"component"},'component',_vm.wrapper.attributes,false),[_vm._v("\n      "+_vm._s(_vm.name)+"\n    ")])]:[_vm._v("\n    "+_vm._s(_vm.name)+"\n  ")]],2)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ 379:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_SidebarNavItem_vue__ = __webpack_require__(380);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_SidebarNavItem_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_SidebarNavItem_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_3d29e8f0_hasScoped_false_node_modules_vue_loader_lib_selector_type_template_index_0_SidebarNavItem_vue__ = __webpack_require__(381);
var normalizeComponent = __webpack_require__(2)
/* script */

/* template */

/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_SidebarNavItem_vue___default.a,
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_3d29e8f0_hasScoped_false_node_modules_vue_loader_lib_selector_type_template_index_0_SidebarNavItem_vue__["a" /* default */],
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),

/***/ 380:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _toConsumableArray2 = __webpack_require__(99);

var _toConsumableArray3 = _interopRequireDefault(_toConsumableArray2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
  name: 'sidebar-nav-item',
  props: {
    classes: {
      type: String,
      default: ''
    }
  },
  computed: {
    classList: function classList() {
      return ['nav-item'].concat((0, _toConsumableArray3.default)(this.itemClasses));
    },
    itemClasses: function itemClasses() {
      return this.classes ? this.classes.split(' ') : '';
    }
  }
};

/***/ }),

/***/ 381:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('li',{class:_vm.classList},[_vm._t("default")],2)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ 382:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"sidebar"},[_c('SidebarHeader'),_vm._v(" "),_c('SidebarForm'),_vm._v(" "),_c('nav',{staticClass:"sidebar-nav"},[_c('div',{attrs:{"slot":"header"},slot:"header"}),_vm._v(" "),_c('ul',{staticClass:"nav"},[_vm._l((_vm.navItems),function(item,index){return [(item.title)?[_c('SidebarNavTitle',{attrs:{"name":item.name,"classes":item.class,"wrapper":item.wrapper}})]:(item.divider)?[_c('li',{staticClass:"divider"})]:[(item.children)?[_c('SidebarNavDropdown',{attrs:{"name":item.name,"url":item.url,"icon":item.icon}},[_vm._l((item.children),function(childL1,index){return [(childL1.children)?[_c('SidebarNavDropdown',{attrs:{"name":childL1.name,"url":childL1.url,"icon":childL1.icon}},_vm._l((childL1.children),function(childL2,index){return _c('li',{staticClass:"nav-item"},[_c('SidebarNavLink',{attrs:{"name":childL2.name,"url":childL2.url,"icon":childL2.icon,"badge":childL2.badge,"variant":item.variant}})],1)}))]:[_c('SidebarNavItem',{attrs:{"classes":item.class}},[_c('SidebarNavLink',{attrs:{"name":childL1.name,"url":childL1.url,"icon":childL1.icon,"badge":childL1.badge,"variant":item.variant}})],1)]]})],2)]:[_c('SidebarNavItem',{attrs:{"classes":item.class}},[_c('SidebarNavLink',{attrs:{"name":item.name,"url":item.url,"icon":item.icon,"badge":item.badge,"variant":item.variant}})],1)]]]})],2),_vm._v(" "),_vm._t("default")],2),_vm._v(" "),_c('SidebarFooter'),_vm._v(" "),_c('SidebarMinimizer')],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ 383:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Switch_vue__ = __webpack_require__(384);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Switch_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Switch_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_b3f3403c_hasScoped_false_node_modules_vue_loader_lib_selector_type_template_index_0_Switch_vue__ = __webpack_require__(385);
var normalizeComponent = __webpack_require__(2)
/* script */

/* template */

/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Switch_vue___default.a,
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_b3f3403c_hasScoped_false_node_modules_vue_loader_lib_selector_type_template_index_0_Switch_vue__["a" /* default */],
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),

/***/ 384:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = {
  model: {
    prop: 'checked',
    event: 'change'
  },
  props: {
    value: {
      default: true
    },
    uncheckedValue: {
      default: false
    },
    checked: {
      default: false
    },
    type: {
      type: String,
      default: 'default'
    },
    variant: {
      type: String,
      default: ''
    },
    pill: {
      type: Boolean,
      default: false
    },
    on: {
      type: String,
      default: null
    },
    off: {
      type: String,
      default: null
    },
    size: {
      type: String,
      default: null
    }
  },
  computed: {
    classList: function classList() {
      return ['switch', this.switchType, this.switchVariant, this.switchPill, this.switchSize];
    },
    switchType: function switchType() {
      return this.type ? 'switch-' + this.type : 'switch-default';
    },
    switchVariant: function switchVariant() {
      return this.variant ? 'switch-' + this.variant : 'switch-secondary';
    },
    switchPill: function switchPill() {
      return !this.pill ? null : 'switch-pill';
    },
    switchSize: function switchSize() {
      return this.size ? 'switch-' + this.size : '';
    },
    isChecked: function isChecked() {
      return this.checked === this.value;
    },
    isOn: function isOn() {
      return !this.on ? null : true;
    }
  },
  methods: {
    handleChange: function handleChange(_ref) {
      var checked = _ref.target.checked;

      this.$emit('change', checked ? this.value : this.uncheckedValue);
    }
  }
};

/***/ }),

/***/ 385:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('label',{class:_vm.classList},[_c('input',{staticClass:"switch-input",attrs:{"type":"checkbox"},domProps:{"value":_vm.value,"checked":_vm.isChecked},on:{"change":_vm.handleChange}}),_vm._v(" "),(_vm.isOn)?[_c('span',{staticClass:"switch-label",attrs:{"data-on":_vm.on,"data-off":_vm.off}})]:[_c('span',{staticClass:"switch-label"})],_vm._v(" "),_c('span',{staticClass:"switch-handle"})],2)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ 386:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"app"},[_c('AppHeader'),_vm._v(" "),_c('div',{staticClass:"app-body"},[_c('Sidebar',{attrs:{"navItems":_vm.nav}}),_vm._v(" "),_c('main',{staticClass:"main"},[_c('breadcrumb',{attrs:{"list":_vm.list}}),_vm._v(" "),_c('div',{staticClass:"container-fluid"},[_c('router-view')],1)],1)],1),_vm._v(" "),_c('AppFooter')],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ 387:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Limited_vue__ = __webpack_require__(389);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Limited_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Limited_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_56d1b650_hasScoped_false_node_modules_vue_loader_lib_selector_type_template_index_0_Limited_vue__ = __webpack_require__(390);
function injectStyle (ssrContext) {
  __webpack_require__(388)
}
var normalizeComponent = __webpack_require__(2)
/* script */

/* template */

/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Limited_vue___default.a,
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_56d1b650_hasScoped_false_node_modules_vue_loader_lib_selector_type_template_index_0_Limited_vue__["a" /* default */],
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),

/***/ 388:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 389:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _nav = __webpack_require__(97);

var _nav2 = _interopRequireDefault(_nav);

var _components = __webpack_require__(98);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
  name: 'limited',
  components: {
    AppFooter: _components.Footer,
    Breadcrumb: _components.Breadcrumb
  },
  data: function data() {
    return {
      nav: _nav2.default.items
    };
  },

  computed: {
    name: function name() {
      return this.$route.name;
    },
    list: function list() {
      return this.$route.matched;
    }
  }
};

/***/ }),

/***/ 390:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"app limited"},[_c('div',{staticClass:"app-body"},[_c('main',{staticClass:"main"},[_c('breadcrumb',{attrs:{"list":_vm.list}}),_vm._v(" "),_c('div',{staticClass:"container-fluid"},[_c('router-view')],1)],1)]),_vm._v(" "),_c('AppFooter')],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ 391:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_PresenceManagement_vue__ = __webpack_require__(393);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_PresenceManagement_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_PresenceManagement_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_15cffe1a_hasScoped_false_node_modules_vue_loader_lib_selector_type_template_index_0_PresenceManagement_vue__ = __webpack_require__(474);
function injectStyle (ssrContext) {
  __webpack_require__(392)
}
var normalizeComponent = __webpack_require__(2)
/* script */

/* template */

/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_PresenceManagement_vue___default.a,
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_15cffe1a_hasScoped_false_node_modules_vue_loader_lib_selector_type_template_index_0_PresenceManagement_vue__["a" /* default */],
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),

/***/ 392:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 393:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _stringify = __webpack_require__(109);

var _stringify2 = _interopRequireDefault(_stringify);

var _typeof2 = __webpack_require__(63);

var _typeof3 = _interopRequireDefault(_typeof2);

var _prmJobs = __webpack_require__(409);

var _vueSelect = __webpack_require__(473);

var _vueSelect2 = _interopRequireDefault(_vueSelect);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var prmJobs = void 0;

exports.default = {
  name: 'presence-management',
  beforeRouteLeave: function beforeRouteLeave(to, from, next) {
    clearInterval(this.interval);
    next();
  },

  components: {
    vSelect: _vueSelect2.default
  },
  watch: {
    options: {
      handler: function handler(value) {
        var module = value.module.value;

        this.posts = module === 'create-posts' || module === 'delete-posts';
      },

      deep: true
    }
  },
  data: function data() {
    var date = new Date(Date.now());

    date.setMonth(date.getMonth() - 1);

    return {
      posts: false,
      options: {
        module: null,
        client: null,
        stamp: date.getFullYear() + '-' + ('0' + (date.getMonth() + 1)).slice(-2),
        businessName: '',
        strict: true,
        post: null
      },
      columns: [{
        label: 'Report',
        field: 'name',
        filterable: true
      }, {
        label: 'Status',
        thClass: 'text-center'
      }, {
        label: 'Requested',
        field: 'createdAt',
        filterable: true,
        thClass: 'text-center'
      }],
      clients: [],
      files: {
        posts: []
      },
      rows: [],
      notifyState: {},
      modules: [{
        value: 'prm-report',
        label: 'Full Report'
      }, {
        value: 'gather-places',
        label: 'Get Google Places Data'
      }, {
        value: 'gather-gmb',
        label: 'Get Raw Google My Business Data'
      }, {
        value: 'gather-insights',
        label: 'Get Raw Insights Data'
      }, {
        value: 'create-posts',
        label: 'Create Posts in GMB'
      }, {
        value: 'delete-posts',
        label: 'Delete Posts in GMB'
      }, {
        value: 'gather-posts',
        label: 'Get Raw Posts Insights Data'
      }, {
        value: 'gather-reviews',
        label: 'Get Raw Review Data'
      }, {
        value: 'compare-nap',
        label: 'Create Raw Accuracy Report'
      }, {
        value: 'calculate-reviews',
        label: 'Create Review Report'
      }, {
        value: 'calculate-accuracy',
        label: 'Create Accuracy Report'
      }, {
        value: 'calculate-insights',
        label: 'Create Insights Report'
      }, {
        value: 'calculate-posts',
        label: 'Create Post Insights Report'
      }, {
        value: 'calculate-studio-insights',
        label: 'Create Data Studio Insights Report'
      }]
    };
  },

  methods: {
    refreshJobs: function refreshJobs() {
      var _this = this;

      this.$log.debug('Refreshing Jobs');

      prmJobs.getJobs().then(function (jobs) {
        _this.$log.debug('Received AWS Reporting Job Data', jobs);
        _this.rows = jobs.map(function (job) {
          var report = _this.modules.find(function (module) {
            return module.value === job.parameters.module;
          }).label.split(' ');
          var client = _this.clients.find(function (client) {
            return client.value === job.parameters.slug;
          });
          var name = (typeof client === 'undefined' ? 'undefined' : (0, _typeof3.default)(client)) === 'object' ? client.label : job.parameters.businessName;

          if (job.parameters.module !== 'gather-places') {
            report.push(job.parameters.stamp);
          }

          report.splice(1, 0, name);

          try {
            var key = job.jobId;
            var state = job.status;

            if (key in _this.notifyState) {
              if (_this.notifyState[key] !== state && _this.notifyState[key] === 'RUNNING') {
                _this.$notification.show(report.join(' '), {
                  body: state
                }, {});
              }
            }

            _this.notifyState[key] = state;
          } catch (error) {
            _this.$log.error(error);
          }

          return {
            jobId: job.jobId,
            name: report.join(' '),
            status: job.status,
            createdAt: new Date(job.createdAt).toISOString()
          };
        });

        console.log(_this.rows);
      }).catch(function (error) {
        if (error.code === 'ExpiredTokenException' || error.code === 'CredentialsError') {
          _this.$auth.signOut();
        } else {
          _this.$log.warn((0, _stringify2.default)(error));

          _this.$notify({
            title: 'AWS API Error',
            text: error.message ? error.message : 'Gateway issue',
            type: 'alert-warning',
            duration: 5000
          });
        }
      });
    },
    runJob: function runJob() {
      var _this2 = this;

      this.$validator.validateAll().then(function (status) {
        if (status) {
          var job = {
            job: 'raptorPresenceManagementReport:2',
            queue: 'arn:aws:batch:us-east-1:976741133712:job-queue/raptorSchemaUpdates',
            name: 'raptorProductionPresenceManagementReport',
            parameters: {
              module: _this2.options.module.value,
              slug: _this2.options.client && _this2.options.client.value || 'false',
              stamp: _this2.options.stamp,
              file: _this2.options.file && _this2.options.file.value || '0',
              businessName: _this2.options.businessName || 'false',
              strict: _this2.options.strict ? 'true' : 'false'
            }
          };

          _this2.$dialog.confirm('<p>Are you sure you want to run this report?</p>', {
            loader: true,
            html: true,
            okText: 'Run Job',
            cancelText: 'Cancel'
          }).then(function (dialog) {
            if (prmJobs) {
              prmJobs.runJob(job).then(function () {
                dialog.close();
                _this2.$notify({ title: 'The report has been queued' });
                clearInterval(_this2.interval);
                _this2.refreshJobs();
                _this2.interval = setInterval(function () {
                  return _this2.refreshJobs();
                }, 15000);
              }, function (error) {
                dialog.close();
                _this2.$notify({
                  title: 'Unable to start job',
                  text: error.body.message || error.message || error.toString(),
                  type: 'alert-danger',
                  duration: 5000
                });
              });
            }
          }).catch(function () {});
        }
      });
    }
  },
  mounted: function mounted() {
    var _this3 = this;

    this.$log.debug('Presence management mounted');

    prmJobs = new _prmJobs.PrMJobs(this);

    prmJobs.getClients().then(function (clients) {
      _this3.$log.debug('Loaded clients');
      _this3.clients = clients.map(function (client) {
        return {
          label: client.Client,
          value: client.Slug
        };
      }).sort(function (a, b) {
        return a.label < b.label ? -1 : a.label > b.label ? 1 : 0;
      });

      _this3.refreshJobs();
      _this3.interval = setInterval(function () {
        return _this3.refreshJobs();
      }, 15000);
    }).catch(function (error) {
      _this3.$log.error(error);

      _this3.$notify({
        title: 'Unable to retrieve client list',
        text: 'Please try refreshing the page',
        type: 'alert-error',
        duration: 10000
      });
    });

    prmJobs.getPostsFiles().then(function (files) {
      _this3.files.posts = files.filter(function (file) {
        return file.name.indexOf('Copy') === -1;
      }).map(function (file) {
        return {
          label: file.name,
          value: file.name
        };
      });
    }).catch(function (error) {
      _this3.$log.error(error);

      _this3.$notify({
        title: 'Unable to Posts content list',
        text: 'Please try refreshing the page',
        type: 'alert-error',
        duration: 10000
      });
    });
  }
};

/***/ }),

/***/ 409:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.PrMJobs = undefined;

var _promise = __webpack_require__(115);

var _promise2 = _interopRequireDefault(_promise);

var _getPrototypeOf = __webpack_require__(421);

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = __webpack_require__(53);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(54);

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__(424);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(425);

var _inherits3 = _interopRequireDefault(_inherits2);

var _raptorJobs = __webpack_require__(67);

var _csvParse = __webpack_require__(461);

var _csvParse2 = _interopRequireDefault(_csvParse);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var PrMJobs = exports.PrMJobs = function (_RaptorJobs) {
  (0, _inherits3.default)(PrMJobs, _RaptorJobs);

  function PrMJobs(Vue, options) {
    (0, _classCallCheck3.default)(this, PrMJobs);

    var _this = (0, _possibleConstructorReturn3.default)(this, (PrMJobs.__proto__ || (0, _getPrototypeOf2.default)(PrMJobs)).call(this));

    _this._app = Vue;
    return _this;
  }

  (0, _createClass3.default)(PrMJobs, [{
    key: 'authAndCall',
    value: function authAndCall(call) {
      var _this2 = this;

      return new _promise2.default(function (resolve, reject) {
        if (typeof gapi === 'undefined') {
          _this2._app.$auth.onChange(function (state) {
            if (state) {
              _this2[call](function (error, response) {
                if (error) {
                  reject(error);
                } else {
                  resolve(response);
                }
              });
            }
          });
        } else {
          _this2[call](function (error, response) {
            if (error) {
              reject(error);
            } else {
              resolve(response);
            }
          });
        }
      });
    }
  }, {
    key: 'getClients',
    value: function getClients() {
      return this.authAndCall('_getClients');
    }
  }, {
    key: 'getPostsFiles',
    value: function getPostsFiles() {
      return this.authAndCall('_getPostsFiles');
    }
  }, {
    key: 'getJobs',
    value: function getJobs() {
      return this._batchJobs(['arn:aws:batch:us-east-1:976741133712:job-queue/raptorSchemaUpdates']).then(function (jobs) {
        return jobs.filter(function (job) {
          return job.jobName.split('-').shift() === 'raptorProductionPresenceManagementReport';
        });
      });
    }
  }, {
    key: '_getClients',
    value: function _getClients(callback) {
      gapi.client.load('drive', 'v3', function () {
        gapi.client.drive.files.export({
          'fileId': '1UT2ZxyHbNI3Wtzp1qVocvURTEYLUdRmTRV5saOoMB_k',
          'mimeType': 'text/csv'
        }).then(function (response) {
          (0, _csvParse2.default)(response.body, {
            columns: true,
            trim: true
          }, callback);
        }).catch(function (error) {
          return callback(error);
        });
      });
    }
  }, {
    key: '_getPostsFiles',
    value: function _getPostsFiles(callback) {
      gapi.client.load('drive', 'v3', function () {
        gapi.client.drive.files.list({
          'fields': 'files(name)',
          'q': '(\'1JS5cvooTPcpBoXA9WyEhHpS3mL-sBZet\' in parents)'
        }).then(function (response) {
          callback(null, response.result.files);
        }).catch(function (error) {
          return callback(error);
        });
      });
    }
  }]);
  return PrMJobs;
}(_raptorJobs.RaptorJobs);

/***/ }),

/***/ 456:
/***/ (function(module, exports) {

module.exports = {"version":"2.0","metadata":{"apiVersion":"2015-10-07","endpointPrefix":"events","jsonVersion":"1.1","protocol":"json","serviceFullName":"Amazon CloudWatch Events","serviceId":"CloudWatch Events","signatureVersion":"v4","targetPrefix":"AWSEvents","uid":"events-2015-10-07"},"operations":{"ActivateEventSource":{"input":{"type":"structure","required":["Name"],"members":{"Name":{}}}},"CreateEventBus":{"input":{"type":"structure","required":["Name"],"members":{"Name":{},"EventSourceName":{},"Tags":{"shape":"S5"}}},"output":{"type":"structure","members":{"EventBusArn":{}}}},"CreatePartnerEventSource":{"input":{"type":"structure","required":["Name","Account"],"members":{"Name":{},"Account":{}}},"output":{"type":"structure","members":{"EventSourceArn":{}}}},"DeactivateEventSource":{"input":{"type":"structure","required":["Name"],"members":{"Name":{}}}},"DeleteEventBus":{"input":{"type":"structure","required":["Name"],"members":{"Name":{}}}},"DeletePartnerEventSource":{"input":{"type":"structure","required":["Name","Account"],"members":{"Name":{},"Account":{}}}},"DeleteRule":{"input":{"type":"structure","required":["Name"],"members":{"Name":{},"EventBusName":{},"Force":{"type":"boolean"}}}},"DescribeEventBus":{"input":{"type":"structure","members":{"Name":{}}},"output":{"type":"structure","members":{"Name":{},"Arn":{},"Policy":{}}}},"DescribeEventSource":{"input":{"type":"structure","required":["Name"],"members":{"Name":{}}},"output":{"type":"structure","members":{"Arn":{},"CreatedBy":{},"CreationTime":{"type":"timestamp"},"ExpirationTime":{"type":"timestamp"},"Name":{},"State":{}}}},"DescribePartnerEventSource":{"input":{"type":"structure","required":["Name"],"members":{"Name":{}}},"output":{"type":"structure","members":{"Arn":{},"Name":{}}}},"DescribeRule":{"input":{"type":"structure","required":["Name"],"members":{"Name":{},"EventBusName":{}}},"output":{"type":"structure","members":{"Name":{},"Arn":{},"EventPattern":{},"ScheduleExpression":{},"State":{},"Description":{},"RoleArn":{},"ManagedBy":{},"EventBusName":{}}}},"DisableRule":{"input":{"type":"structure","required":["Name"],"members":{"Name":{},"EventBusName":{}}}},"EnableRule":{"input":{"type":"structure","required":["Name"],"members":{"Name":{},"EventBusName":{}}}},"ListEventBuses":{"input":{"type":"structure","members":{"NamePrefix":{},"NextToken":{},"Limit":{"type":"integer"}}},"output":{"type":"structure","members":{"EventBuses":{"type":"list","member":{"type":"structure","members":{"Name":{},"Arn":{},"Policy":{}}}},"NextToken":{}}}},"ListEventSources":{"input":{"type":"structure","members":{"NamePrefix":{},"NextToken":{},"Limit":{"type":"integer"}}},"output":{"type":"structure","members":{"EventSources":{"type":"list","member":{"type":"structure","members":{"Arn":{},"CreatedBy":{},"CreationTime":{"type":"timestamp"},"ExpirationTime":{"type":"timestamp"},"Name":{},"State":{}}}},"NextToken":{}}}},"ListPartnerEventSourceAccounts":{"input":{"type":"structure","required":["EventSourceName"],"members":{"EventSourceName":{},"NextToken":{},"Limit":{"type":"integer"}}},"output":{"type":"structure","members":{"PartnerEventSourceAccounts":{"type":"list","member":{"type":"structure","members":{"Account":{},"CreationTime":{"type":"timestamp"},"ExpirationTime":{"type":"timestamp"},"State":{}}}},"NextToken":{}}}},"ListPartnerEventSources":{"input":{"type":"structure","required":["NamePrefix"],"members":{"NamePrefix":{},"NextToken":{},"Limit":{"type":"integer"}}},"output":{"type":"structure","members":{"PartnerEventSources":{"type":"list","member":{"type":"structure","members":{"Arn":{},"Name":{}}}},"NextToken":{}}}},"ListRuleNamesByTarget":{"input":{"type":"structure","required":["TargetArn"],"members":{"TargetArn":{},"EventBusName":{},"NextToken":{},"Limit":{"type":"integer"}}},"output":{"type":"structure","members":{"RuleNames":{"type":"list","member":{}},"NextToken":{}}}},"ListRules":{"input":{"type":"structure","members":{"NamePrefix":{},"EventBusName":{},"NextToken":{},"Limit":{"type":"integer"}}},"output":{"type":"structure","members":{"Rules":{"type":"list","member":{"type":"structure","members":{"Name":{},"Arn":{},"EventPattern":{},"State":{},"Description":{},"ScheduleExpression":{},"RoleArn":{},"ManagedBy":{},"EventBusName":{}}}},"NextToken":{}}}},"ListTagsForResource":{"input":{"type":"structure","required":["ResourceARN"],"members":{"ResourceARN":{}}},"output":{"type":"structure","members":{"Tags":{"shape":"S5"}}}},"ListTargetsByRule":{"input":{"type":"structure","required":["Rule"],"members":{"Rule":{},"EventBusName":{},"NextToken":{},"Limit":{"type":"integer"}}},"output":{"type":"structure","members":{"Targets":{"shape":"S20"},"NextToken":{}}}},"PutEvents":{"input":{"type":"structure","required":["Entries"],"members":{"Entries":{"type":"list","member":{"type":"structure","members":{"Time":{"type":"timestamp"},"Source":{},"Resources":{"shape":"S2y"},"DetailType":{},"Detail":{},"EventBusName":{}}}}}},"output":{"type":"structure","members":{"FailedEntryCount":{"type":"integer"},"Entries":{"type":"list","member":{"type":"structure","members":{"EventId":{},"ErrorCode":{},"ErrorMessage":{}}}}}}},"PutPartnerEvents":{"input":{"type":"structure","required":["Entries"],"members":{"Entries":{"type":"list","member":{"type":"structure","members":{"Time":{"type":"timestamp"},"Source":{},"Resources":{"shape":"S2y"},"DetailType":{},"Detail":{}}}}}},"output":{"type":"structure","members":{"FailedEntryCount":{"type":"integer"},"Entries":{"type":"list","member":{"type":"structure","members":{"EventId":{},"ErrorCode":{},"ErrorMessage":{}}}}}}},"PutPermission":{"input":{"type":"structure","required":["Action","Principal","StatementId"],"members":{"EventBusName":{},"Action":{},"Principal":{},"StatementId":{},"Condition":{"type":"structure","required":["Type","Key","Value"],"members":{"Type":{},"Key":{},"Value":{}}}}}},"PutRule":{"input":{"type":"structure","required":["Name"],"members":{"Name":{},"ScheduleExpression":{},"EventPattern":{},"State":{},"Description":{},"RoleArn":{},"Tags":{"shape":"S5"},"EventBusName":{}}},"output":{"type":"structure","members":{"RuleArn":{}}}},"PutTargets":{"input":{"type":"structure","required":["Rule","Targets"],"members":{"Rule":{},"EventBusName":{},"Targets":{"shape":"S20"}}},"output":{"type":"structure","members":{"FailedEntryCount":{"type":"integer"},"FailedEntries":{"type":"list","member":{"type":"structure","members":{"TargetId":{},"ErrorCode":{},"ErrorMessage":{}}}}}}},"RemovePermission":{"input":{"type":"structure","required":["StatementId"],"members":{"StatementId":{},"EventBusName":{}}}},"RemoveTargets":{"input":{"type":"structure","required":["Rule","Ids"],"members":{"Rule":{},"EventBusName":{},"Ids":{"type":"list","member":{}},"Force":{"type":"boolean"}}},"output":{"type":"structure","members":{"FailedEntryCount":{"type":"integer"},"FailedEntries":{"type":"list","member":{"type":"structure","members":{"TargetId":{},"ErrorCode":{},"ErrorMessage":{}}}}}}},"TagResource":{"input":{"type":"structure","required":["ResourceARN","Tags"],"members":{"ResourceARN":{},"Tags":{"shape":"S5"}}},"output":{"type":"structure","members":{}}},"TestEventPattern":{"input":{"type":"structure","required":["EventPattern","Event"],"members":{"EventPattern":{},"Event":{}}},"output":{"type":"structure","members":{"Result":{"type":"boolean"}}}},"UntagResource":{"input":{"type":"structure","required":["ResourceARN","TagKeys"],"members":{"ResourceARN":{},"TagKeys":{"type":"list","member":{}}}},"output":{"type":"structure","members":{}}}},"shapes":{"S5":{"type":"list","member":{"type":"structure","required":["Key","Value"],"members":{"Key":{},"Value":{}}}},"S20":{"type":"list","member":{"type":"structure","required":["Id","Arn"],"members":{"Id":{},"Arn":{},"RoleArn":{},"Input":{},"InputPath":{},"InputTransformer":{"type":"structure","required":["InputTemplate"],"members":{"InputPathsMap":{"type":"map","key":{},"value":{}},"InputTemplate":{}}},"KinesisParameters":{"type":"structure","required":["PartitionKeyPath"],"members":{"PartitionKeyPath":{}}},"RunCommandParameters":{"type":"structure","required":["RunCommandTargets"],"members":{"RunCommandTargets":{"type":"list","member":{"type":"structure","required":["Key","Values"],"members":{"Key":{},"Values":{"type":"list","member":{}}}}}}},"EcsParameters":{"type":"structure","required":["TaskDefinitionArn"],"members":{"TaskDefinitionArn":{},"TaskCount":{"type":"integer"},"LaunchType":{},"NetworkConfiguration":{"type":"structure","members":{"awsvpcConfiguration":{"type":"structure","required":["Subnets"],"members":{"Subnets":{"shape":"S2m"},"SecurityGroups":{"shape":"S2m"},"AssignPublicIp":{}}}}},"PlatformVersion":{},"Group":{}}},"BatchParameters":{"type":"structure","required":["JobDefinition","JobName"],"members":{"JobDefinition":{},"JobName":{},"ArrayProperties":{"type":"structure","members":{"Size":{"type":"integer"}}},"RetryStrategy":{"type":"structure","members":{"Attempts":{"type":"integer"}}}}},"SqsParameters":{"type":"structure","members":{"MessageGroupId":{}}}}}},"S2m":{"type":"list","member":{}},"S2y":{"type":"list","member":{}}}}

/***/ }),

/***/ 457:
/***/ (function(module, exports) {

module.exports = {"pagination":{}}

/***/ }),

/***/ 459:
/***/ (function(module, exports) {

module.exports = {"version":"2.0","metadata":{"apiVersion":"2014-03-28","endpointPrefix":"logs","jsonVersion":"1.1","protocol":"json","serviceFullName":"Amazon CloudWatch Logs","serviceId":"CloudWatch Logs","signatureVersion":"v4","targetPrefix":"Logs_20140328","uid":"logs-2014-03-28"},"operations":{"AssociateKmsKey":{"input":{"type":"structure","required":["logGroupName","kmsKeyId"],"members":{"logGroupName":{},"kmsKeyId":{}}}},"CancelExportTask":{"input":{"type":"structure","required":["taskId"],"members":{"taskId":{}}}},"CreateExportTask":{"input":{"type":"structure","required":["logGroupName","from","to","destination"],"members":{"taskName":{},"logGroupName":{},"logStreamNamePrefix":{},"from":{"type":"long"},"to":{"type":"long"},"destination":{},"destinationPrefix":{}}},"output":{"type":"structure","members":{"taskId":{}}}},"CreateLogGroup":{"input":{"type":"structure","required":["logGroupName"],"members":{"logGroupName":{},"kmsKeyId":{},"tags":{"shape":"Se"}}}},"CreateLogStream":{"input":{"type":"structure","required":["logGroupName","logStreamName"],"members":{"logGroupName":{},"logStreamName":{}}}},"DeleteDestination":{"input":{"type":"structure","required":["destinationName"],"members":{"destinationName":{}}}},"DeleteLogGroup":{"input":{"type":"structure","required":["logGroupName"],"members":{"logGroupName":{}}}},"DeleteLogStream":{"input":{"type":"structure","required":["logGroupName","logStreamName"],"members":{"logGroupName":{},"logStreamName":{}}}},"DeleteMetricFilter":{"input":{"type":"structure","required":["logGroupName","filterName"],"members":{"logGroupName":{},"filterName":{}}}},"DeleteResourcePolicy":{"input":{"type":"structure","members":{"policyName":{}}}},"DeleteRetentionPolicy":{"input":{"type":"structure","required":["logGroupName"],"members":{"logGroupName":{}}}},"DeleteSubscriptionFilter":{"input":{"type":"structure","required":["logGroupName","filterName"],"members":{"logGroupName":{},"filterName":{}}}},"DescribeDestinations":{"input":{"type":"structure","members":{"DestinationNamePrefix":{},"nextToken":{},"limit":{"type":"integer"}}},"output":{"type":"structure","members":{"destinations":{"type":"list","member":{"shape":"Sx"}},"nextToken":{}}}},"DescribeExportTasks":{"input":{"type":"structure","members":{"taskId":{},"statusCode":{},"nextToken":{},"limit":{"type":"integer"}}},"output":{"type":"structure","members":{"exportTasks":{"type":"list","member":{"type":"structure","members":{"taskId":{},"taskName":{},"logGroupName":{},"from":{"type":"long"},"to":{"type":"long"},"destination":{},"destinationPrefix":{},"status":{"type":"structure","members":{"code":{},"message":{}}},"executionInfo":{"type":"structure","members":{"creationTime":{"type":"long"},"completionTime":{"type":"long"}}}}}},"nextToken":{}}}},"DescribeLogGroups":{"input":{"type":"structure","members":{"logGroupNamePrefix":{},"nextToken":{},"limit":{"type":"integer"}}},"output":{"type":"structure","members":{"logGroups":{"type":"list","member":{"type":"structure","members":{"logGroupName":{},"creationTime":{"type":"long"},"retentionInDays":{"type":"integer"},"metricFilterCount":{"type":"integer"},"arn":{},"storedBytes":{"type":"long"},"kmsKeyId":{}}}},"nextToken":{}}}},"DescribeLogStreams":{"input":{"type":"structure","required":["logGroupName"],"members":{"logGroupName":{},"logStreamNamePrefix":{},"orderBy":{},"descending":{"type":"boolean"},"nextToken":{},"limit":{"type":"integer"}}},"output":{"type":"structure","members":{"logStreams":{"type":"list","member":{"type":"structure","members":{"logStreamName":{},"creationTime":{"type":"long"},"firstEventTimestamp":{"type":"long"},"lastEventTimestamp":{"type":"long"},"lastIngestionTime":{"type":"long"},"uploadSequenceToken":{},"arn":{},"storedBytes":{"deprecated":true,"deprecatedMessage":"Starting on June 17, 2019, this parameter will be deprecated for log streams, and will be reported as zero. This change applies only to log streams. The storedBytes parameter for log groups is not affected.","type":"long"}}}},"nextToken":{}}}},"DescribeMetricFilters":{"input":{"type":"structure","members":{"logGroupName":{},"filterNamePrefix":{},"nextToken":{},"limit":{"type":"integer"},"metricName":{},"metricNamespace":{}}},"output":{"type":"structure","members":{"metricFilters":{"type":"list","member":{"type":"structure","members":{"filterName":{},"filterPattern":{},"metricTransformations":{"shape":"S1v"},"creationTime":{"type":"long"},"logGroupName":{}}}},"nextToken":{}}}},"DescribeQueries":{"input":{"type":"structure","members":{"logGroupName":{},"status":{},"maxResults":{"type":"integer"},"nextToken":{}}},"output":{"type":"structure","members":{"queries":{"type":"list","member":{"type":"structure","members":{"queryId":{},"queryString":{},"status":{},"createTime":{"type":"long"},"logGroupName":{}}}},"nextToken":{}}}},"DescribeResourcePolicies":{"input":{"type":"structure","members":{"nextToken":{},"limit":{"type":"integer"}}},"output":{"type":"structure","members":{"resourcePolicies":{"type":"list","member":{"shape":"S2a"}},"nextToken":{}}}},"DescribeSubscriptionFilters":{"input":{"type":"structure","required":["logGroupName"],"members":{"logGroupName":{},"filterNamePrefix":{},"nextToken":{},"limit":{"type":"integer"}}},"output":{"type":"structure","members":{"subscriptionFilters":{"type":"list","member":{"type":"structure","members":{"filterName":{},"logGroupName":{},"filterPattern":{},"destinationArn":{},"roleArn":{},"distribution":{},"creationTime":{"type":"long"}}}},"nextToken":{}}}},"DisassociateKmsKey":{"input":{"type":"structure","required":["logGroupName"],"members":{"logGroupName":{}}}},"FilterLogEvents":{"input":{"type":"structure","required":["logGroupName"],"members":{"logGroupName":{},"logStreamNames":{"type":"list","member":{}},"logStreamNamePrefix":{},"startTime":{"type":"long"},"endTime":{"type":"long"},"filterPattern":{},"nextToken":{},"limit":{"type":"integer"},"interleaved":{"deprecated":true,"deprecatedMessage":"Starting on June 17, 2019, this parameter will be ignored and the value will be assumed to be true. The response from this operation will always interleave events from multiple log streams within a log group.","type":"boolean"}}},"output":{"type":"structure","members":{"events":{"type":"list","member":{"type":"structure","members":{"logStreamName":{},"timestamp":{"type":"long"},"message":{},"ingestionTime":{"type":"long"},"eventId":{}}}},"searchedLogStreams":{"type":"list","member":{"type":"structure","members":{"logStreamName":{},"searchedCompletely":{"type":"boolean"}}}},"nextToken":{}}}},"GetLogEvents":{"input":{"type":"structure","required":["logGroupName","logStreamName"],"members":{"logGroupName":{},"logStreamName":{},"startTime":{"type":"long"},"endTime":{"type":"long"},"nextToken":{},"limit":{"type":"integer"},"startFromHead":{"type":"boolean"}}},"output":{"type":"structure","members":{"events":{"type":"list","member":{"type":"structure","members":{"timestamp":{"type":"long"},"message":{},"ingestionTime":{"type":"long"}}}},"nextForwardToken":{},"nextBackwardToken":{}}}},"GetLogGroupFields":{"input":{"type":"structure","required":["logGroupName"],"members":{"logGroupName":{},"time":{"type":"long"}}},"output":{"type":"structure","members":{"logGroupFields":{"type":"list","member":{"type":"structure","members":{"name":{},"percent":{"type":"integer"}}}}}}},"GetLogRecord":{"input":{"type":"structure","required":["logRecordPointer"],"members":{"logRecordPointer":{}}},"output":{"type":"structure","members":{"logRecord":{"type":"map","key":{},"value":{}}}}},"GetQueryResults":{"input":{"type":"structure","required":["queryId"],"members":{"queryId":{}}},"output":{"type":"structure","members":{"results":{"type":"list","member":{"type":"list","member":{"type":"structure","members":{"field":{},"value":{}}}}},"statistics":{"type":"structure","members":{"recordsMatched":{"type":"double"},"recordsScanned":{"type":"double"},"bytesScanned":{"type":"double"}}},"status":{}}}},"ListTagsLogGroup":{"input":{"type":"structure","required":["logGroupName"],"members":{"logGroupName":{}}},"output":{"type":"structure","members":{"tags":{"shape":"Se"}}}},"PutDestination":{"input":{"type":"structure","required":["destinationName","targetArn","roleArn"],"members":{"destinationName":{},"targetArn":{},"roleArn":{}}},"output":{"type":"structure","members":{"destination":{"shape":"Sx"}}}},"PutDestinationPolicy":{"input":{"type":"structure","required":["destinationName","accessPolicy"],"members":{"destinationName":{},"accessPolicy":{}}}},"PutLogEvents":{"input":{"type":"structure","required":["logGroupName","logStreamName","logEvents"],"members":{"logGroupName":{},"logStreamName":{},"logEvents":{"type":"list","member":{"type":"structure","required":["timestamp","message"],"members":{"timestamp":{"type":"long"},"message":{}}}},"sequenceToken":{}}},"output":{"type":"structure","members":{"nextSequenceToken":{},"rejectedLogEventsInfo":{"type":"structure","members":{"tooNewLogEventStartIndex":{"type":"integer"},"tooOldLogEventEndIndex":{"type":"integer"},"expiredLogEventEndIndex":{"type":"integer"}}}}}},"PutMetricFilter":{"input":{"type":"structure","required":["logGroupName","filterName","filterPattern","metricTransformations"],"members":{"logGroupName":{},"filterName":{},"filterPattern":{},"metricTransformations":{"shape":"S1v"}}}},"PutResourcePolicy":{"input":{"type":"structure","members":{"policyName":{},"policyDocument":{}}},"output":{"type":"structure","members":{"resourcePolicy":{"shape":"S2a"}}}},"PutRetentionPolicy":{"input":{"type":"structure","required":["logGroupName","retentionInDays"],"members":{"logGroupName":{},"retentionInDays":{"type":"integer"}}}},"PutSubscriptionFilter":{"input":{"type":"structure","required":["logGroupName","filterName","filterPattern","destinationArn"],"members":{"logGroupName":{},"filterName":{},"filterPattern":{},"destinationArn":{},"roleArn":{},"distribution":{}}}},"StartQuery":{"input":{"type":"structure","required":["startTime","endTime","queryString"],"members":{"logGroupName":{},"logGroupNames":{"type":"list","member":{}},"startTime":{"type":"long"},"endTime":{"type":"long"},"queryString":{},"limit":{"type":"integer"}}},"output":{"type":"structure","members":{"queryId":{}}}},"StopQuery":{"input":{"type":"structure","required":["queryId"],"members":{"queryId":{}}},"output":{"type":"structure","members":{"success":{"type":"boolean"}}}},"TagLogGroup":{"input":{"type":"structure","required":["logGroupName","tags"],"members":{"logGroupName":{},"tags":{"shape":"Se"}}}},"TestMetricFilter":{"input":{"type":"structure","required":["filterPattern","logEventMessages"],"members":{"filterPattern":{},"logEventMessages":{"type":"list","member":{}}}},"output":{"type":"structure","members":{"matches":{"type":"list","member":{"type":"structure","members":{"eventNumber":{"type":"long"},"eventMessage":{},"extractedValues":{"type":"map","key":{},"value":{}}}}}}}},"UntagLogGroup":{"input":{"type":"structure","required":["logGroupName","tags"],"members":{"logGroupName":{},"tags":{"type":"list","member":{}}}}}},"shapes":{"Se":{"type":"map","key":{},"value":{}},"Sx":{"type":"structure","members":{"destinationName":{},"targetArn":{},"roleArn":{},"accessPolicy":{},"arn":{},"creationTime":{"type":"long"}}},"S1v":{"type":"list","member":{"type":"structure","required":["metricName","metricNamespace","metricValue"],"members":{"metricName":{},"metricNamespace":{},"metricValue":{},"defaultValue":{"type":"double"}}}},"S2a":{"type":"structure","members":{"policyName":{},"policyDocument":{},"lastUpdatedTime":{"type":"long"}}}}}

/***/ }),

/***/ 460:
/***/ (function(module, exports) {

module.exports = {"pagination":{"DescribeDestinations":{"input_token":"nextToken","limit_key":"limit","output_token":"nextToken","result_key":"destinations"},"DescribeLogGroups":{"input_token":"nextToken","limit_key":"limit","output_token":"nextToken","result_key":"logGroups"},"DescribeLogStreams":{"input_token":"nextToken","limit_key":"limit","output_token":"nextToken","result_key":"logStreams"},"DescribeMetricFilters":{"input_token":"nextToken","limit_key":"limit","output_token":"nextToken","result_key":"metricFilters"},"DescribeSubscriptionFilters":{"input_token":"nextToken","limit_key":"limit","output_token":"nextToken","result_key":"subscriptionFilters"},"FilterLogEvents":{"input_token":"nextToken","limit_key":"limit","output_token":"nextToken","result_key":["events","searchedLogStreams"]},"GetLogEvents":{"input_token":"nextToken","limit_key":"limit","output_token":"nextForwardToken","result_key":"events"}}}

/***/ }),

/***/ 463:
/***/ (function(module, exports) {

/* (ignored) */

/***/ }),

/***/ 465:
/***/ (function(module, exports) {

/* (ignored) */

/***/ }),

/***/ 474:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',{staticClass:"card"},[_c('div',{staticClass:"card-header"},[_vm._v("\n      Run Report\n    ")]),_vm._v(" "),_c('div',{staticClass:"card-body"},[_c('form',{on:{"submit":function($event){$event.preventDefault();_vm.runJob($event)}}},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-12 col-md-7 col-lg-5"},[_c('div',{staticClass:"form-group"},[_c('v-select',{directives:[{name:"validate",rawName:"v-validate",value:('required'),expression:"'required'"}],attrs:{"name":"Report type","options":_vm.modules,"placeholder":"Select a report...","data-vv-value-path":"options.module.value","data-vv-name":"module"},model:{value:(_vm.options.module),callback:function ($$v) {_vm.options.module=$$v},expression:"options.module"}}),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.errors.has('module')),expression:"errors.has('module')"}],staticClass:"bg-warning"},[_vm._v(_vm._s(_vm.errors.first('module')))])],1)]),_vm._v(" "),_c('div',{staticClass:"col-12 col-sm-10 col-md-10 col-lg-6"},[(_vm.options.module && _vm.options.module.value == 'gather-places')?_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-12 col-sm-8"},[_c('div',{staticClass:"form-group"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.options.businessName),expression:"options.businessName"}],staticClass:"form-control",attrs:{"type":"text","placeholder":"Places business name..."},domProps:{"value":(_vm.options.businessName)},on:{"input":function($event){if($event.target.composing){ return; }_vm.options.businessName=$event.target.value}}})])]),_vm._v(" "),_c('div',{staticClass:"col-12 col-sm-4"},[_c('div',{staticClass:"form-check"},[_c('div',{staticClass:"form-check-label"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.options.strict),expression:"options.strict"}],attrs:{"type":"checkbox"},domProps:{"checked":Array.isArray(_vm.options.strict)?_vm._i(_vm.options.strict,null)>-1:(_vm.options.strict)},on:{"__c":function($event){var $$a=_vm.options.strict,$$el=$event.target,$$c=$$el.checked?(true):(false);if(Array.isArray($$a)){var $$v=null,$$i=_vm._i($$a,$$v);if($$el.checked){$$i<0&&(_vm.options.strict=$$a.concat([$$v]))}else{$$i>-1&&(_vm.options.strict=$$a.slice(0,$$i).concat($$a.slice($$i+1)))}}else{_vm.options.strict=$$c}}}}),_vm._v("\n                    Strict Match\n                  ")])])])]):_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-12 col-sm-6"},[_c('v-select',{directives:[{name:"validate",rawName:"v-validate",value:('required'),expression:"'required'"}],attrs:{"options":_vm.clients,"placeholder":"Select a client...","data-vv-name":"client"},model:{value:(_vm.options.client),callback:function ($$v) {_vm.options.client=$$v},expression:"options.client"}}),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.errors.has('client')),expression:"errors.has('client')"}],staticClass:"bg-warning"},[_vm._v(_vm._s(_vm.errors.first('client')))])],1),_vm._v(" "),(_vm.posts)?_c('div',{staticClass:"col-12 col-sm-6"},[_c('v-select',{directives:[{name:"validate",rawName:"v-validate",value:(_vm.posts ? 'required' : ''),expression:"posts ? 'required' : ''"}],attrs:{"options":_vm.files.posts,"placeholder":"Select a file...","data-vv-name":"file"},model:{value:(_vm.options.file),callback:function ($$v) {_vm.options.file=$$v},expression:"options.file"}}),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.errors.has('file')),expression:"errors.has('file')"}],staticClass:"bg-warning"},[_vm._v(_vm._s(_vm.errors.first('file')))])],1):_vm._e(),_vm._v(" "),(!_vm.posts)?_c('div',{staticClass:"col-12 col-sm-6"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.options.stamp),expression:"options.stamp"},{name:"validate",rawName:"v-validate",value:(_vm.posts ? '' : 'required'),expression:"posts ? '' : 'required'"}],staticClass:"form-control",attrs:{"type":"month","name":"stamp"},domProps:{"value":(_vm.options.stamp)},on:{"input":function($event){if($event.target.composing){ return; }_vm.options.stamp=$event.target.value}}}),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.errors.has('stamp')),expression:"errors.has('stamp')"}],staticClass:"bg-warning"},[_vm._v(_vm._s(_vm.errors.first('stamp')))])]):_vm._e()])]),_vm._v(" "),_vm._m(0)])])])]),_vm._v(" "),_vm._m(1),_vm._v(" "),_c('div',{staticClass:"card"},[_c('div',{staticClass:"card-header"},[_vm._v("\n      Reporting Jobs\n      "),_c('div',{staticClass:"actions pull-right"},[_c('b-dropdown',{staticClass:"m-md-2",attrs:{"id":"legend","text":"Legend","right":"","variant":"primary"}},[_c('b-dropdown-item',[_c('i',{staticClass:"text-primary fa fa-hourglass-o",attrs:{"title":"Job has been submitted","aria-hidden":"true"}}),_vm._v("\n              Job submitted\n          ")]),_vm._v(" "),_c('b-dropdown-item',[_c('i',{staticClass:"text-primary fa fa-hourglass-start",attrs:{"title":"Job has been accepted","aria-hidden":"true"}}),_vm._v("\n             Job accepted\n          ")]),_vm._v(" "),_c('b-dropdown-item',[_c('i',{staticClass:"text-primary fa fa-hourglass-half",attrs:{"title":"Job is waiting on resources","aria-hidden":"true"}}),_vm._v("\n             Job queued\n          ")]),_vm._v(" "),_c('b-dropdown-item',[_c('i',{staticClass:"text-primary fa fa-hourglass-end",attrs:{"title":"Job is getting ready to run","aria-hidden":"true"}}),_vm._v("\n             Job starting\n          ")]),_vm._v(" "),_c('b-dropdown-item',[_c('i',{staticClass:"text-primary fa fa-spinner fa-spin",attrs:{"title":"Job is in progress","aria-hidden":"true"}}),_vm._v("\n             Job in progress\n          ")]),_vm._v(" "),_c('b-dropdown-item',[_c('i',{staticClass:"text-success fa fa-check",attrs:{"title":"Job completed","aria-hidden":"true"}}),_vm._v("\n             Job completed\n          ")]),_vm._v(" "),_c('b-dropdown-item',[_c('i',{staticClass:"text-danger fa fa-times",attrs:{"title":"Job did not finish","aria-hidden":"true"}}),_vm._v("\n             Job failed\n          ")])],1)],1)]),_vm._v(" "),_c('div',{staticClass:"card-body"},[_c('vue-good-table',{attrs:{"columns":_vm.columns,"rows":_vm.rows,"defaultSortBy":{field: 'createdAt', type: 'desc'},"globalSearch":true,"paginate":true,"perPage":50,"styleClass":"table condensed table-bordered table-striped"},scopedSlots:_vm._u([{key:"table-column",fn:function(props){return [(props.column.label === 'Status')?_c('span',[_c('span',{staticClass:"hidden-xs"},[_vm._v("\n                "+_vm._s(props.column.label)+"\n              ")]),_vm._v(" "),_c('i',{staticClass:"fa fa-wrench",attrs:{"aria-hidden":"true","title":props.column.label}})]):_c('span',[_vm._v("\n              "+_vm._s(props.column.label)+"\n           ")])]}},{key:"table-row",fn:function(props){return [_c('td',{staticClass:"fancy"},[_vm._v(_vm._s(props.row.name))]),_vm._v(" "),_c('td',{staticClass:"text-center"},[(props.row.status === 'SUBMITTED')?_c('span',[_c('i',{staticClass:"text-primary fa fa-2x fa-hourglass-o",attrs:{"title":"Job has been submitted","aria-hidden":"true"}})]):(props.row.status === 'PENDING')?_c('span',[_c('i',{staticClass:"text-primary fa fa-2x fa-hourglass-start",attrs:{"title":"Job has been accepted","aria-hidden":"true"}})]):(props.row.status === 'RUNNABLE')?_c('span',[_c('i',{staticClass:"text-primary fa fa-2x fa-hourglass-half",attrs:{"title":"Job is waiting on resources","aria-hidden":"true"}})]):(props.row.status === 'STARTING')?_c('span',[_c('i',{staticClass:"text-primary fa fa-2x fa-hourglass-end",attrs:{"title":"Job is getting ready to run","aria-hidden":"true"}})]):_c('span',[_c('router-link',{attrs:{"to":{ name: 'Job Report', params: { jobId: props.row.jobId }}}},[(props.row.status === 'SUCCEEDED')?_c('span',[_c('i',{staticClass:"text-success fa fa-2x fa-check",attrs:{"title":"Job completed","aria-hidden":"true"}})]):(props.row.status === 'FAILED')?_c('span',[_c('i',{staticClass:"text-danger fa fa-2x fa-times",attrs:{"title":"Job did not finish","aria-hidden":"true"}})]):(props.row.status === 'RUNNING')?_c('span',[_c('i',{staticClass:"text-primary fa fa-2x fa-spinner fa-spin",attrs:{"title":"Job is in progress","aria-hidden":"true"}})]):_vm._e()])],1)]),_vm._v(" "),_c('td',{staticClass:"text-center"},[_vm._v("\n            "+_vm._s(_vm._f("moment")(props.row.createdAt,"h:mm a"))+"\n          ")])]}}])})],1)]),_vm._v(" "),_c('router-view')],1)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"col-12 col-sm-2 col-md-1"},[_c('button',{staticClass:"btn btn-primary",attrs:{"type":"submit"}},[_vm._v("Run")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"table-header clearfix"},[_c('h4',{staticClass:"table-title pull-left"})])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ 475:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_RecurringJobs_vue__ = __webpack_require__(477);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_RecurringJobs_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_RecurringJobs_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_5b50c487_hasScoped_false_node_modules_vue_loader_lib_selector_type_template_index_0_RecurringJobs_vue__ = __webpack_require__(481);
function injectStyle (ssrContext) {
  __webpack_require__(476)
}
var normalizeComponent = __webpack_require__(2)
/* script */

/* template */

/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_RecurringJobs_vue___default.a,
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_5b50c487_hasScoped_false_node_modules_vue_loader_lib_selector_type_template_index_0_RecurringJobs_vue__["a" /* default */],
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),

/***/ 476:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 477:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _stringify = __webpack_require__(109);

var _stringify2 = _interopRequireDefault(_stringify);

var _keys = __webpack_require__(478);

var _keys2 = _interopRequireDefault(_keys);

var _raptorJobs = __webpack_require__(67);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var raptorJobs = void 0;

exports.default = {
  name: 'recurring-jobs',
  beforeRouteLeave: function beforeRouteLeave(to, from, next) {
    clearInterval(this.interval);
    next();
  },
  data: function data() {
    return {
      columns: [{
        label: 'Name',
        field: 'name',
        filterable: true
      }, {
        label: 'Staging',
        thClass: 'text-center'
      }, {
        label: 'Production',
        thClass: 'text-center'
      }],
      notifyState: {},
      rows: []
    };
  },

  methods: {
    toggleSchedule: function toggleSchedule(job) {
      var _this = this;

      var state = job.enabled ? 'Disable' : 'Enable';

      this.$dialog.confirm('<p>' + state + ' Job?</p>', {
        loader: true,
        html: true,
        okText: state,
        cancelText: 'Cancel'
      }).then(function (dialog) {
        raptorJobs.enableSchedule(job).then(function () {
          dialog.close();
          _this.$notify({
            title: 'Job schedule is now ' + state.toLowerCase() + 'd'
          });
          clearInterval(_this.interval);
          _this.refreshJobs();
          _this.interval = setInterval(function () {
            return _this.refreshJobs();
          }, 15000);
        }, function (error) {
          dialog.close();
          _this.$notify({
            title: 'Unable enable schedule',
            text: error.message || error.toString(),
            type: 'alert-danger',
            duration: 5000
          });
        });
      }).catch(function () {});
    },
    runJob: function runJob(job) {
      var _this2 = this;

      if (job.target.split(':').pop() === 'raptorPagesJob') {
        job.queue = 'arn:aws:batch:us-east-1:976741133712:job-queue/raptorPagesUpdates';
      } else {
        job.queue = 'arn:aws:batch:us-east-1:976741133712:job-queue/raptorSchemaUpdates';
      }

      this.$dialog.confirm('<p>Are you sure you want to start this job?</p><small>Running a job incurs hosting costs.</small>', {
        loader: true,
        html: true,
        okText: 'Run Job',
        cancelText: 'Cancel'
      }).then(function (dialog) {
        if (raptorJobs) {
          raptorJobs.runJob(job).then(function () {
            dialog.close();
            _this2.$notify({
              title: 'The job has been queued'
            });
            clearInterval(_this2.interval);
            _this2.refreshJobs();
            _this2.interval = setInterval(function () {
              return _this2.refreshJobs();
            }, 15000);
          }, function (error) {
            dialog.close();
            _this2.$notify({
              title: 'Unable to start job',
              text: error.body.message || error.message || error.toString(),
              type: 'alert-danger',
              duration: 5000
            });
          });
        }
      }).catch(function () {});
    },
    refreshJobs: function refreshJobs() {
      var _this3 = this;

      this.$log.debug('Refreshing Jobs');

      raptorJobs.getRules(['arn:aws:lambda:us-east-1:976741133712:function:raptorSchemaJob', 'arn:aws:lambda:us-east-1:976741133712:function:raptorPagesJob'], ['raptorSchemaUpdates', 'raptorPagesUpdates']).then(function (rules) {
        _this3.$log.debug('Received AWS Job Data', rules);
        _this3.rows = rules;

        rules.forEach(function (rule) {
          try {
            (0, _keys2.default)(rule.environments).filter(function (environment) {
              return rule.environments[environment].history;
            }).forEach(function (environment) {
              var key = rule.arn + environment;
              var state = rule.environments[environment].history.status;

              if (key in _this3.notifyState) {
                if (_this3.notifyState[key] !== state && _this3.notifyState[key] === 'RUNNING') {
                  _this3.$notification.show(rule.name, {
                    body: state
                  }, {});
                }
              }

              _this3.notifyState[key] = state;
            });
          } catch (error) {
            _this3.$log.error(error);
          }
        });
      }).catch(function (error) {
        if (error.code === 'ExpiredTokenException' || error.code === 'CredentialsError') {
          _this3.$auth.signOut();
        } else {
          _this3.$log.warn((0, _stringify2.default)(error));

          _this3.$notify({
            title: 'AWS API Error',
            text: error.message ? error.message : 'Gateway issue',
            type: 'alert-warning',
            duration: 5000
          });
        }
      });
    }
  },
  mounted: function mounted() {
    var _this4 = this;

    this.$log.debug('Dashboard mounted');

    raptorJobs = new _raptorJobs.RaptorJobs();

    this.refreshJobs();

    this.interval = setInterval(function () {
      return _this4.refreshJobs();
    }, 15000);
  }
};

/***/ }),

/***/ 481:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',{staticClass:"table-header clearfix"},[_c('div',{staticClass:"actions pull-right"},[_c('b-dropdown',{staticClass:"m-md-2",attrs:{"id":"legend","text":"Legend","right":"","variant":"primary"}},[_c('b-dropdown-item',[_c('i',{staticClass:"text-success fa fa-play",attrs:{"title":"Run job","aria-hidden":"true"}}),_vm._v("\n           Start job\n        ")]),_vm._v(" "),_c('b-dropdown-item',[_c('i',{staticClass:"text-primary fa fa-hourglass-o",attrs:{"title":"Job has been submitted","aria-hidden":"true"}}),_vm._v("\n            Job submitted\n        ")]),_vm._v(" "),_c('b-dropdown-item',[_c('i',{staticClass:"text-primary fa fa-hourglass-start",attrs:{"title":"Job has been accepted","aria-hidden":"true"}}),_vm._v("\n           Job accepted\n        ")]),_vm._v(" "),_c('b-dropdown-item',[_c('i',{staticClass:"text-primary fa fa-hourglass-half",attrs:{"title":"Job is waiting on resources","aria-hidden":"true"}}),_vm._v("\n           Job queued\n        ")]),_vm._v(" "),_c('b-dropdown-item',[_c('i',{staticClass:"text-primary fa fa-hourglass-end",attrs:{"title":"Job is getting ready to run","aria-hidden":"true"}}),_vm._v("\n           Job starting\n        ")]),_vm._v(" "),_c('b-dropdown-item',[_c('i',{staticClass:"text-primary fa fa-spinner fa-spin",attrs:{"title":"Job is in progress","aria-hidden":"true"}}),_vm._v("\n           Job in progress\n        ")]),_vm._v(" "),_c('b-dropdown-item',[_c('i',{staticClass:"text-success fa fa-check",attrs:{"title":"Job completed","aria-hidden":"true"}}),_vm._v("\n           Job completed\n        ")]),_vm._v(" "),_c('b-dropdown-item',[_c('i',{staticClass:"text-danger fa fa-times",attrs:{"title":"Job did not finish","aria-hidden":"true"}}),_vm._v("\n           Job failed\n        ")]),_vm._v(" "),_c('b-dropdown-item',[_c('i',{staticClass:"text-warning fa fa-2x fa-clock-o",attrs:{"title":"Job has not run recently","aria-hidden":"true"}}),_vm._v("\n           Job has not run recently\n        ")]),_vm._v(" "),_c('b-dropdown-item',[_c('i',{staticClass:"text-success fa fa-2x fa-clock-o",attrs:{"title":"Job schedule is enabled","aria-hidden":"true"}}),_vm._v("\n          Job schedule is enabled\n        ")]),_vm._v(" "),_c('b-dropdown-item',[_c('i',{staticClass:"text-danger fa fa-2x fa-clock-o",attrs:{"title":"Job schedule is disabled","aria-hidden":"true"}}),_vm._v("\n          Job schedule is disabled\n        ")]),_vm._v(" "),_c('b-dropdown-item',[_c('i',{staticClass:"text-danger fa fa-exclamation-triangle",attrs:{"title":"Environment not configured","aria-hidden":"true"}}),_vm._v("\n           Environment not found\n        ")])],1)],1),_vm._v(" "),_c('h4',{staticClass:"table-title pull-left"},[_vm._v("Recurring Jobs")])]),_vm._v(" "),_c('vue-good-table',{attrs:{"columns":_vm.columns,"rows":_vm.rows,"defaultSortBy":{field: 'name', type: 'asc'},"globalSearch":true,"paginate":true,"perPage":50,"styleClass":"table condensed table-bordered table-striped"},scopedSlots:_vm._u([{key:"table-column",fn:function(props){return [(props.column.label === 'Staging')?_c('span',[_c('span',{staticClass:"hidden-xs"},[_vm._v("\n            "+_vm._s(props.column.label)+"\n          ")]),_vm._v(" "),_c('i',{staticClass:"fa fa-wrench",attrs:{"aria-hidden":"true","title":props.column.label}})]):(props.column.label === 'Production')?_c('span',[_c('span',{staticClass:"hidden-xs"},[_vm._v("\n            "+_vm._s(props.column.label)+"\n          ")]),_vm._v(" "),_c('i',{staticClass:"fa fa-eye",attrs:{"aria-hidden":"true","title":props.column.label}})]):_c('span',[_vm._v("\n          "+_vm._s(props.column.label)+"\n       ")])]}},{key:"table-row",fn:function(props){return [_c('td',{staticClass:"fancy"},[_vm._v(_vm._s(props.row.name))]),_vm._v(" "),_c('td',{staticClass:"text-center"},[(props.row.environments.staging)?_c('span',[(props.row.environments.staging.history)?_c('span',[(props.row.environments.staging.history.status === 'SUBMITTED')?_c('span',[_c('i',{staticClass:"text-primary fa fa-2x fa-hourglass-o",attrs:{"title":"Job has been submitted","aria-hidden":"true"}})]):(props.row.environments.staging.history.status === 'PENDING')?_c('span',[_c('i',{staticClass:"text-primary fa fa-2x fa-hourglass-start",attrs:{"title":"Job has been accepted","aria-hidden":"true"}})]):(props.row.environments.staging.history.status === 'RUNNABLE')?_c('span',[_c('i',{staticClass:"text-primary fa fa-2x fa-hourglass-half",attrs:{"title":"Job is waiting on resources","aria-hidden":"true"}})]):(props.row.environments.staging.history.status === 'STARTING')?_c('span',[_c('i',{staticClass:"text-primary fa fa-2x fa-hourglass-end",attrs:{"title":"Job is getting ready to run","aria-hidden":"true"}})]):_c('span',[_c('router-link',{attrs:{"to":{ name: 'Job Log', params: { jobId: props.row.environments.staging.history.jobId }}}},[(props.row.environments.staging.history.status === 'SUCCEEDED')?_c('span',[_c('i',{staticClass:"text-success fa fa-2x fa-check",attrs:{"title":"Job completed","aria-hidden":"true"}})]):(props.row.environments.staging.history.status === 'FAILED')?_c('span',[_c('i',{staticClass:"text-danger fa fa-2x fa-times",attrs:{"title":"Job did not finish","aria-hidden":"true"}})]):(props.row.environments.staging.history.status === 'RUNNING')?_c('span',[_c('i',{staticClass:"text-primary fa fa-2x fa-spinner fa-spin",attrs:{"title":"Job is in progress","aria-hidden":"true"}})]):_vm._e()])],1)]):_c('span',[_c('i',{staticClass:"text-warning fa fa-2x fa-clock-o",attrs:{"title":"Job has not run recently","aria-hidden":"true"}})]),_vm._v(" "),(!props.row.environments.staging.history || props.row.environments.staging.history.status.match(/SUCCEEDED|FAILED/))?_c('span',[_c('a',{on:{"click":function($event){_vm.runJob(props.row.environments.staging)}}},[_c('i',{staticClass:"text-success fa fa-2x fa-play",attrs:{"title":"Run job","aria-hidden":"true"}})])]):_vm._e(),_vm._v(" "),_c('a',{on:{"click":function($event){_vm.toggleSchedule(props.row.environments.staging)}}},[(props.row.environments.staging.enabled)?_c('span',[_c('i',{staticClass:"text-success fa fa-2x fa-clock-o",attrs:{"title":"Job schedule is enabled","aria-hidden":"true"}})]):_c('span',[_c('i',{staticClass:"text-danger fa fa-2x fa-clock-o",attrs:{"title":"Job schedule is disabled","aria-hidden":"true"}})])])]):_c('span',[_c('i',{staticClass:"text-danger fa fa-2x fa-exclamation-triangle",attrs:{"title":"Environment not configured","aria-hidden":"true"}})])]),_vm._v(" "),_c('td',{staticClass:"text-center"},[(props.row.environments.production)?_c('span',[(props.row.environments.production.history)?_c('span',[(props.row.environments.production.history.status === 'SUBMITTED')?_c('span',[_c('i',{staticClass:"text-primary fa fa-2x fa-hourglass-o",attrs:{"title":"Job has been submitted","aria-hidden":"true"}})]):(props.row.environments.production.history.status === 'PENDING')?_c('span',[_c('i',{staticClass:"text-primary fa fa-2x fa-hourglass-start",attrs:{"title":"Job has been accepted","aria-hidden":"true"}})]):(props.row.environments.production.history.status === 'RUNNABLE')?_c('span',[_c('i',{staticClass:"text-primary fa fa-2x fa-hourglass-half",attrs:{"title":"Job is waiting on resources","aria-hidden":"true"}})]):(props.row.environments.production.history.status === 'STARTING')?_c('span',[_c('i',{staticClass:"text-primary fa fa-2x fa-hourglass-end",attrs:{"title":"Job is getting ready to run","aria-hidden":"true"}})]):_c('span',[_c('router-link',{attrs:{"to":{ name: 'Job Log', params: { jobId: props.row.environments.production.history.jobId }}}},[(props.row.environments.production.history.status === 'SUCCEEDED')?_c('span',[_c('i',{staticClass:"text-success fa fa-2x fa-check",attrs:{"title":"Job completed","aria-hidden":"true"}})]):(props.row.environments.production.history.status === 'FAILED')?_c('span',[_c('i',{staticClass:"text-danger fa fa-2x fa-times",attrs:{"title":"Job did not finish","aria-hidden":"true"}})]):(props.row.environments.production.history.status === 'RUNNING')?_c('span',[_c('i',{staticClass:"text-primary fa fa-2x fa-spinner fa-spin",attrs:{"title":"Job is in progress","aria-hidden":"true"}})]):_vm._e()])],1)]):_c('span',[_c('i',{staticClass:"text-warning fa fa-2x fa-clock-o",attrs:{"title":"Job has not run recently","aria-hidden":"true"}})]),_vm._v(" "),(!props.row.environments.production.history || props.row.environments.production.history.status.match(/SUCCEEDED|FAILED/))?_c('span',[_c('a',{on:{"click":function($event){_vm.runJob(props.row.environments.production)}}},[_c('i',{staticClass:"text-success fa fa-2x fa-play",attrs:{"title":"Run job","aria-hidden":"true"}})])]):_vm._e(),_vm._v(" "),_c('a',{on:{"click":function($event){_vm.toggleSchedule(props.row.environments.production)}}},[(props.row.environments.production.enabled)?_c('span',[_c('i',{staticClass:"text-success fa fa-2x fa-clock-o",attrs:{"title":"Job schedule is enabled","aria-hidden":"true"}})]):_c('span',[_c('i',{staticClass:"text-danger fa fa-2x fa-clock-o",attrs:{"title":"Job schedule is disabled","aria-hidden":"true"}})])])]):_c('span',[_c('i',{staticClass:"text-danger fa fa-2x fa-exclamation-triangle",attrs:{"title":"Environment not configured","aria-hidden":"true"}})])])]}}])}),_vm._v(" "),_c('router-view')],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ 482:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_JobLog_vue__ = __webpack_require__(484);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_JobLog_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_JobLog_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_6fae1e43_hasScoped_false_node_modules_vue_loader_lib_selector_type_template_index_0_JobLog_vue__ = __webpack_require__(485);
function injectStyle (ssrContext) {
  __webpack_require__(483)
}
var normalizeComponent = __webpack_require__(2)
/* script */

/* template */

/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_JobLog_vue___default.a,
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_6fae1e43_hasScoped_false_node_modules_vue_loader_lib_selector_type_template_index_0_JobLog_vue__["a" /* default */],
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),

/***/ 483:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 484:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _raptorJobs = __webpack_require__(67);

var raptorJobs = void 0;

exports.default = {
  data: function data() {
    return {
      job: null
    };
  },

  methods: {
    hide: function hide() {
      this.$modal.hide('job-log');
    },
    close: function close(_close) {
      this.$router.go(-1);
    }
  },
  mounted: function mounted() {
    var _this = this;

    this.$modal.show('job-log');

    raptorJobs = new _raptorJobs.RaptorJobs('arn:aws:lambda:us-east-1:976741133712:function:raptorSchemaJob');

    raptorJobs.getLogs(this.$route.params.jobId, '/aws/batch/job').then(function (job) {
      _this.$log.debug('Received CloudWatch Logs', job);
      _this.job = job;
    });
  }
};

/***/ }),

/***/ 485:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('modal',{attrs:{"width":"80%","height":"550px","name":"job-log"},on:{"closed":_vm.close}},[_c('div',{staticClass:"pull-right"},[_c('a',{staticClass:"close",attrs:{"aria-label":"Close"},on:{"click":_vm.hide}},[_c('span',{attrs:{"aria-hidden":"true"}},[_vm._v("×")])])]),_vm._v(" "),(_vm.job)?_c('div',[_c('div',{staticClass:"card border-light"},[_c('div',{staticClass:"card-body"},[_c('h4',{staticClass:"card-title"},[_vm._v(_vm._s(_vm.job.name))]),_vm._v(" "),_c('h6',{staticClass:"card-subtitle mb-2 text-muted"},[_vm._v("\n          Started:\n          "+_vm._s(_vm._f("moment")(_vm.job.started,'MMMM Do YYYY h:mma'))+"\n        ")])]),_vm._v(" "),_c('pre',{staticClass:"pre-scrollable border"},[_vm._v("        "),_vm._l((_vm.job.logs),function(event){return _c('div',[_vm._v(_vm._s(event.message))])}),_vm._v("\n      ")],2),_vm._v(" "),_c('div',{staticClass:"card-body"},[_c('div',{staticClass:"pull-right"},[_c('a',{staticClass:"card-link",attrs:{"href":"javascript:void(0)"},on:{"click":_vm.hide}},[_vm._v("Dismiss")])]),_vm._v(" "),_c('a',{attrs:{"target":"_blank","href":'https://console.aws.amazon.com/cloudwatch/home?region=us-east-1#logEventViewer:group=/aws/batch/job;stream=' + _vm.job.stream}},[_vm._v("\n          CloudWatch Logs\n        ")])])])]):_c('div',{staticClass:"loading"},[_c('a',{on:{"click":_vm.hide}},[_c('i',{staticClass:"text-primary fa fa-spinner fa-spin fa-5x",attrs:{"title":"Job is in progress","aria-hidden":"true"}})])])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ 486:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Login_vue__ = __webpack_require__(488);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Login_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Login_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_1ba54c1d_hasScoped_false_node_modules_vue_loader_lib_selector_type_template_index_0_Login_vue__ = __webpack_require__(489);
function injectStyle (ssrContext) {
  __webpack_require__(487)
}
var normalizeComponent = __webpack_require__(2)
/* script */

/* template */

/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Login_vue___default.a,
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_1ba54c1d_hasScoped_false_node_modules_vue_loader_lib_selector_type_template_index_0_Login_vue__["a" /* default */],
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),

/***/ 487:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 488:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = {
  name: 'Login',
  data: function data(router) {
    return {
      section: 'Login',
      response: ''
    };
  },
  methods: {
    signIn: function signIn() {
      var _this = this;

      this.$auth.signIn(function (error) {
        if (error) {
          _this.response = error.toString();
        } else {
          _this.$router.push({
            name: 'Home'
          });
        }
      });
    }
  }
};

/***/ }),

/***/ 489:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"container container-table text-center"},[(_vm.response)?_c('div',{staticClass:"text-red"},[_c('p',[_vm._v(_vm._s(_vm.response))])]):_vm._e(),_vm._v(" "),_c('div',{staticClass:"middle"},[_c('a',{attrs:{"id":"signin-button"},on:{"click":_vm.signIn}},[_vm._v("\n      Sign in with Google\n    ")])])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ 497:
/***/ (function(module, exports, __webpack_require__) {

var map = {
	"./af": 127,
	"./af.js": 127,
	"./ar": 128,
	"./ar-dz": 129,
	"./ar-dz.js": 129,
	"./ar-kw": 130,
	"./ar-kw.js": 130,
	"./ar-ly": 131,
	"./ar-ly.js": 131,
	"./ar-ma": 132,
	"./ar-ma.js": 132,
	"./ar-sa": 133,
	"./ar-sa.js": 133,
	"./ar-tn": 134,
	"./ar-tn.js": 134,
	"./ar.js": 128,
	"./az": 135,
	"./az.js": 135,
	"./be": 136,
	"./be.js": 136,
	"./bg": 137,
	"./bg.js": 137,
	"./bn": 138,
	"./bn.js": 138,
	"./bo": 139,
	"./bo.js": 139,
	"./br": 140,
	"./br.js": 140,
	"./bs": 141,
	"./bs.js": 141,
	"./ca": 142,
	"./ca.js": 142,
	"./cs": 143,
	"./cs.js": 143,
	"./cv": 144,
	"./cv.js": 144,
	"./cy": 145,
	"./cy.js": 145,
	"./da": 146,
	"./da.js": 146,
	"./de": 147,
	"./de-at": 148,
	"./de-at.js": 148,
	"./de-ch": 149,
	"./de-ch.js": 149,
	"./de.js": 147,
	"./dv": 150,
	"./dv.js": 150,
	"./el": 151,
	"./el.js": 151,
	"./en-au": 152,
	"./en-au.js": 152,
	"./en-ca": 153,
	"./en-ca.js": 153,
	"./en-gb": 154,
	"./en-gb.js": 154,
	"./en-ie": 155,
	"./en-ie.js": 155,
	"./en-nz": 156,
	"./en-nz.js": 156,
	"./eo": 157,
	"./eo.js": 157,
	"./es": 158,
	"./es-do": 159,
	"./es-do.js": 159,
	"./es.js": 158,
	"./et": 160,
	"./et.js": 160,
	"./eu": 161,
	"./eu.js": 161,
	"./fa": 162,
	"./fa.js": 162,
	"./fi": 163,
	"./fi.js": 163,
	"./fo": 164,
	"./fo.js": 164,
	"./fr": 165,
	"./fr-ca": 166,
	"./fr-ca.js": 166,
	"./fr-ch": 167,
	"./fr-ch.js": 167,
	"./fr.js": 165,
	"./fy": 168,
	"./fy.js": 168,
	"./gd": 169,
	"./gd.js": 169,
	"./gl": 170,
	"./gl.js": 170,
	"./gom-latn": 171,
	"./gom-latn.js": 171,
	"./he": 172,
	"./he.js": 172,
	"./hi": 173,
	"./hi.js": 173,
	"./hr": 174,
	"./hr.js": 174,
	"./hu": 175,
	"./hu.js": 175,
	"./hy-am": 176,
	"./hy-am.js": 176,
	"./id": 177,
	"./id.js": 177,
	"./is": 178,
	"./is.js": 178,
	"./it": 179,
	"./it.js": 179,
	"./ja": 180,
	"./ja.js": 180,
	"./jv": 181,
	"./jv.js": 181,
	"./ka": 182,
	"./ka.js": 182,
	"./kk": 183,
	"./kk.js": 183,
	"./km": 184,
	"./km.js": 184,
	"./kn": 185,
	"./kn.js": 185,
	"./ko": 186,
	"./ko.js": 186,
	"./ky": 187,
	"./ky.js": 187,
	"./lb": 188,
	"./lb.js": 188,
	"./lo": 189,
	"./lo.js": 189,
	"./lt": 190,
	"./lt.js": 190,
	"./lv": 191,
	"./lv.js": 191,
	"./me": 192,
	"./me.js": 192,
	"./mi": 193,
	"./mi.js": 193,
	"./mk": 194,
	"./mk.js": 194,
	"./ml": 195,
	"./ml.js": 195,
	"./mr": 196,
	"./mr.js": 196,
	"./ms": 197,
	"./ms-my": 198,
	"./ms-my.js": 198,
	"./ms.js": 197,
	"./my": 199,
	"./my.js": 199,
	"./nb": 200,
	"./nb.js": 200,
	"./ne": 201,
	"./ne.js": 201,
	"./nl": 202,
	"./nl-be": 203,
	"./nl-be.js": 203,
	"./nl.js": 202,
	"./nn": 204,
	"./nn.js": 204,
	"./pa-in": 205,
	"./pa-in.js": 205,
	"./pl": 206,
	"./pl.js": 206,
	"./pt": 207,
	"./pt-br": 208,
	"./pt-br.js": 208,
	"./pt.js": 207,
	"./ro": 209,
	"./ro.js": 209,
	"./ru": 210,
	"./ru.js": 210,
	"./sd": 211,
	"./sd.js": 211,
	"./se": 212,
	"./se.js": 212,
	"./si": 213,
	"./si.js": 213,
	"./sk": 214,
	"./sk.js": 214,
	"./sl": 215,
	"./sl.js": 215,
	"./sq": 216,
	"./sq.js": 216,
	"./sr": 217,
	"./sr-cyrl": 218,
	"./sr-cyrl.js": 218,
	"./sr.js": 217,
	"./ss": 219,
	"./ss.js": 219,
	"./sv": 220,
	"./sv.js": 220,
	"./sw": 221,
	"./sw.js": 221,
	"./ta": 222,
	"./ta.js": 222,
	"./te": 223,
	"./te.js": 223,
	"./tet": 224,
	"./tet.js": 224,
	"./th": 225,
	"./th.js": 225,
	"./tl-ph": 226,
	"./tl-ph.js": 226,
	"./tlh": 227,
	"./tlh.js": 227,
	"./tr": 228,
	"./tr.js": 228,
	"./tzl": 229,
	"./tzl.js": 229,
	"./tzm": 230,
	"./tzm-latn": 231,
	"./tzm-latn.js": 231,
	"./tzm.js": 230,
	"./uk": 232,
	"./uk.js": 232,
	"./ur": 233,
	"./ur.js": 233,
	"./uz": 234,
	"./uz-latn": 235,
	"./uz-latn.js": 235,
	"./uz.js": 234,
	"./vi": 236,
	"./vi.js": 236,
	"./x-pseudo": 237,
	"./x-pseudo.js": 237,
	"./yo": 238,
	"./yo.js": 238,
	"./zh-cn": 239,
	"./zh-cn.js": 239,
	"./zh-hk": 240,
	"./zh-hk.js": 240,
	"./zh-tw": 241,
	"./zh-tw.js": 241
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 497;

/***/ }),

/***/ 500:
/***/ (function(module, exports) {

/* (ignored) */

/***/ }),

/***/ 60:
/***/ (function(module, exports) {

/* (ignored) */

/***/ }),

/***/ 67:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.RaptorJobs = undefined;

var _concat = __webpack_require__(433);

var _concat2 = _interopRequireDefault(_concat);

var _values = __webpack_require__(435);

var _values2 = _interopRequireDefault(_values);

var _classCallCheck2 = __webpack_require__(53);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(54);

var _createClass3 = _interopRequireDefault(_createClass2);

var _promise = __webpack_require__(115);

var _promise2 = _interopRequireDefault(_promise);

var _global = __webpack_require__(76);

var _global2 = _interopRequireDefault(_global);

var _changeCase = __webpack_require__(439);

var _changeCase2 = _interopRequireDefault(_changeCase);

var _vue = __webpack_require__(41);

var _vue2 = _interopRequireDefault(_vue);

__webpack_require__(455);

__webpack_require__(458);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function ensureAuth() {
  return new _promise2.default(function (resolve, reject) {
    if (_global2.default.config.credentials.expired) {
      _global2.default.config.credentials.refresh(function () {
        return resolve();
      });
    } else {
      resolve();
    }
  });
}

function mockCORS(api, task) {
  return function (params, callback) {
    var call = ensureAuth().then(function () {
      return _vue2.default.http.post('https://afgbfrzgw9.execute-api.us-east-1.amazonaws.com/prod/raptorJobsMicroservice', {
        api: api,
        task: task,
        params: params,
        credentials: {
          accessKeyId: _global2.default.config.credentials.accessKeyId,
          secretAccessKey: _global2.default.config.credentials.secretAccessKey,
          sessionToken: _global2.default.config.credentials.sessionToken
        }
      }).then(function (response) {
        return response.body;
      });
    });

    if (typeof callback === 'function') {
      call.then(callback);
    } else {
      return {
        promise: function promise() {
          return call;
        }
      };
    }
  };
}

_global2.default.Batch = function () {
  this.describeJobDefinitions = mockCORS('Batch', 'describeJobDefinitions');
  this.listJobs = mockCORS('Batch', 'listJobs');
  this.describeJobs = mockCORS('Batch', 'describeJobs');
  this.submitJob = mockCORS('Batch', 'submitJob');
};

var RaptorJobs = exports.RaptorJobs = function () {
  function RaptorJobs() {
    (0, _classCallCheck3.default)(this, RaptorJobs);

    _vue2.default.$log.debug('Creating APIs');

    this._logsApi = new _global2.default.CloudWatchLogs({
      region: 'us-east-1'
    });

    this._eventsApi = new _global2.default.CloudWatchEvents({
      region: 'us-east-1'
    });

    this._batchApi = new _global2.default.Batch({
      region: 'us-east-1'
    });
  }

  (0, _createClass3.default)(RaptorJobs, [{
    key: 'runJob',
    value: function runJob(job) {
      return this._batchApi.submitJob({
        'jobDefinition': job.job,
        'jobName': job.name + '-' + Date.now().toString(),
        'containerOverrides': {
          'environment': job.environment
        },
        'parameters': job.parameters,
        'jobQueue': job.queue
      }).promise();
    }
  }, {
    key: 'getRules',
    value: function getRules(targets, queues) {
      return _promise2.default.all([this._eventRules(targets), this._batchJobs(queues)]).then(function (values) {
        var jobs = {};
        var history = values[1].reduce(function (map, job) {
          var name = job.jobName.split('-').shift();

          job.time = parseInt(job.jobName.split('-').pop());

          if (!(name in map) || job.time > map[name].time) {
            map[name] = job;
          }

          return map;
        }, {});

        values[0].forEach(function (rule) {
          rule[1].Targets.forEach(function (target) {
            var configuration = JSON.parse(target.Input);
            var name = _changeCase2.default.titleCase(configuration.name).split(' ').slice(1);
            var environment = name.shift();

            name = name.join(' ');

            configuration.name.replace(/([A-Z][A-Z]+)[A-Z]/, function (match, acronym) {
              name = name.replace(_changeCase2.default.titleCase(acronym), acronym);

              return match;
            });

            if (!(name in jobs)) {
              jobs[name] = {
                'name': name,
                'description': rule[0].Description,
                'arn': rule[0].Arn,
                'cron': rule[0].ScheduleExpression,
                'environments': {}
              };
            }

            jobs[name].environments[_changeCase2.default.lower(environment)] = configuration;
            configuration.target = target.Arn;
            configuration.enabled = rule[0].State === 'ENABLED';
            configuration.ruleName = rule[0].Name;

            if (configuration.name in history) {
              configuration.history = history[configuration.name];
            }
          });
        });

        return (0, _values2.default)(jobs);
      });
    }
  }, {
    key: 'getLogs',
    value: function getLogs(jobId, group) {
      var _this = this;

      return this._batchApi.describeJobs({
        'jobs': [jobId]
      }).promise().then(function (response) {
        return _this._logsApi.getLogEvents({
          logGroupName: group,
          logStreamName: response.jobs[0].container.logStreamName,
          startFromHead: true,
          limit: 1000
        }).promise().then(function (logs) {
          var title = response.jobs[0].jobName.split('-').shift();
          var name = _changeCase2.default.titleCase(title).split(' ').slice(1);

          name = name.join(' ');

          title.replace(/([A-Z][A-Z]+)[A-Z]/, function (match, acronym) {
            name = name.replace(_changeCase2.default.titleCase(acronym), acronym);

            return match;
          });

          return {
            logs: logs.events,
            name: name,
            stream: response.jobs[0].container.logStreamName,
            started: response.jobs[0].startedAt
          };
        });
      });
    }
  }, {
    key: 'enableSchedule',
    value: function enableSchedule(job) {
      if (job.enabled) {
        return this._eventsApi.disableRule({
          'Name': job.ruleName
        }).promise();
      } else {
        return this._eventsApi.enableRule({
          'Name': job.ruleName
        }).promise();
      }
    }
  }, {
    key: '_eventRules',
    value: function _eventRules(targets, nextToken) {
      var _this2 = this;

      var rules = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : [];

      return _promise2.default.all(targets.map(function (target) {
        return _this2._eventTargetRules(target);
      })).then(function (rules) {
        return _concat2.default.apply([], rules);
      });
    }
  }, {
    key: '_eventTargetRules',
    value: function _eventTargetRules(target, nextToken) {
      var _this3 = this;

      var rules = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : [];

      var params = {
        TargetArn: target
      };

      if (nextToken) {
        params.NextToken = nextToken;
      }

      return this._eventsApi.listRuleNamesByTarget(params).promise().then(function (response) {
        rules.push.apply(rules, response.RuleNames.map(function (name) {
          return _this3._ruleTargets(name);
        }));

        if (response.NextToken) {
          return _this3._eventTargetRules(target, response.NextToken, rules);
        } else {
          return _promise2.default.all(rules);
        }
      });
    }
  }, {
    key: '_ruleTargets',
    value: function _ruleTargets(ruleName) {
      return _promise2.default.all([this._eventsApi.describeRule({ Name: ruleName }).promise(), this._eventsApi.listTargetsByRule({ Rule: ruleName }).promise()]);
    }
  }, {
    key: '_batchJobs',
    value: function _batchJobs(queues) {
      var _this4 = this;

      return _promise2.default.all(queues.map(function (queue) {
        return _promise2.default.all([_this4._batchJobsStatus('SUBMITTED', queue), _this4._batchJobsStatus('PENDING', queue), _this4._batchJobsStatus('RUNNABLE', queue), _this4._batchJobsStatus('STARTING', queue), _this4._batchJobsStatus('RUNNING', queue), _this4._batchJobsStatus('SUCCEEDED', queue), _this4._batchJobsStatus('FAILED', queue)]);
      })).then(function (jobs) {
        return _concat2.default.apply([], jobs.map(function (list) {
          return _concat2.default.apply([], list);
        }));
      });
    }
  }, {
    key: '_batchJobsStatus',
    value: function _batchJobsStatus(status, queue, nextToken) {
      var _this5 = this;

      var jobs = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : [];

      var params = {
        'jobQueue': queue,
        'jobStatus': status,
        'maxResults': 100
      };
      var responseToken = void 0;

      if (nextToken) {
        params.nextToken = nextToken;
      }

      return this._batchApi.listJobs(params).promise().then(function (response) {
        responseToken = response.nextToken;

        if (response.jobSummaryList.length) {
          return _this5._batchApi.describeJobs({
            jobs: response.jobSummaryList.map(function (job) {
              return job.jobId;
            })
          }).promise();
        } else {
          return { body: { jobs: [] } };
        }
      }).then(function (response) {
        jobs.push.apply(jobs, response.jobs);

        if (responseToken) {
          return _this5._batchJobsStatus(status, queue, responseToken, jobs);
        } else {
          return jobs;
        }
      });
    }
  }]);
  return RaptorJobs;
}();

/***/ }),

/***/ 85:
/***/ (function(module, exports) {

module.exports = {"acm":{"name":"ACM","cors":true},"apigateway":{"name":"APIGateway","cors":true},"applicationautoscaling":{"prefix":"application-autoscaling","name":"ApplicationAutoScaling","cors":true},"appstream":{"name":"AppStream"},"autoscaling":{"name":"AutoScaling","cors":true},"batch":{"name":"Batch"},"budgets":{"name":"Budgets"},"clouddirectory":{"name":"CloudDirectory","versions":["2016-05-10*"]},"cloudformation":{"name":"CloudFormation","cors":true},"cloudfront":{"name":"CloudFront","versions":["2013-05-12*","2013-11-11*","2014-05-31*","2014-10-21*","2014-11-06*","2015-04-17*","2015-07-27*","2015-09-17*","2016-01-13*","2016-01-28*","2016-08-01*","2016-08-20*","2016-09-07*","2016-09-29*","2016-11-25*","2017-03-25*","2017-10-30*","2018-06-18*","2018-11-05*"],"cors":true},"cloudhsm":{"name":"CloudHSM","cors":true},"cloudsearch":{"name":"CloudSearch"},"cloudsearchdomain":{"name":"CloudSearchDomain"},"cloudtrail":{"name":"CloudTrail","cors":true},"cloudwatch":{"prefix":"monitoring","name":"CloudWatch","cors":true},"cloudwatchevents":{"prefix":"events","name":"CloudWatchEvents","versions":["2014-02-03*"],"cors":true},"cloudwatchlogs":{"prefix":"logs","name":"CloudWatchLogs","cors":true},"codebuild":{"name":"CodeBuild","cors":true},"codecommit":{"name":"CodeCommit","cors":true},"codedeploy":{"name":"CodeDeploy","cors":true},"codepipeline":{"name":"CodePipeline","cors":true},"cognitoidentity":{"prefix":"cognito-identity","name":"CognitoIdentity","cors":true},"cognitoidentityserviceprovider":{"prefix":"cognito-idp","name":"CognitoIdentityServiceProvider","cors":true},"cognitosync":{"prefix":"cognito-sync","name":"CognitoSync","cors":true},"configservice":{"prefix":"config","name":"ConfigService","cors":true},"cur":{"name":"CUR","cors":true},"datapipeline":{"name":"DataPipeline"},"devicefarm":{"name":"DeviceFarm","cors":true},"directconnect":{"name":"DirectConnect","cors":true},"directoryservice":{"prefix":"ds","name":"DirectoryService"},"discovery":{"name":"Discovery"},"dms":{"name":"DMS"},"dynamodb":{"name":"DynamoDB","cors":true},"dynamodbstreams":{"prefix":"streams.dynamodb","name":"DynamoDBStreams","cors":true},"ec2":{"name":"EC2","versions":["2013-06-15*","2013-10-15*","2014-02-01*","2014-05-01*","2014-06-15*","2014-09-01*","2014-10-01*","2015-03-01*","2015-04-15*","2015-10-01*","2016-04-01*","2016-09-15*"],"cors":true},"ecr":{"name":"ECR","cors":true},"ecs":{"name":"ECS","cors":true},"efs":{"prefix":"elasticfilesystem","name":"EFS","cors":true},"elasticache":{"name":"ElastiCache","versions":["2012-11-15*","2014-03-24*","2014-07-15*","2014-09-30*"],"cors":true},"elasticbeanstalk":{"name":"ElasticBeanstalk","cors":true},"elb":{"prefix":"elasticloadbalancing","name":"ELB","cors":true},"elbv2":{"prefix":"elasticloadbalancingv2","name":"ELBv2","cors":true},"emr":{"prefix":"elasticmapreduce","name":"EMR","cors":true},"es":{"name":"ES"},"elastictranscoder":{"name":"ElasticTranscoder","cors":true},"firehose":{"name":"Firehose","cors":true},"gamelift":{"name":"GameLift","cors":true},"glacier":{"name":"Glacier"},"health":{"name":"Health"},"iam":{"name":"IAM","cors":true},"importexport":{"name":"ImportExport"},"inspector":{"name":"Inspector","versions":["2015-08-18*"],"cors":true},"iot":{"name":"Iot","cors":true},"iotdata":{"prefix":"iot-data","name":"IotData","cors":true},"kinesis":{"name":"Kinesis","cors":true},"kinesisanalytics":{"name":"KinesisAnalytics"},"kms":{"name":"KMS","cors":true},"lambda":{"name":"Lambda","cors":true},"lexruntime":{"prefix":"runtime.lex","name":"LexRuntime","cors":true},"lightsail":{"name":"Lightsail"},"machinelearning":{"name":"MachineLearning","cors":true},"marketplacecommerceanalytics":{"name":"MarketplaceCommerceAnalytics","cors":true},"marketplacemetering":{"prefix":"meteringmarketplace","name":"MarketplaceMetering"},"mturk":{"prefix":"mturk-requester","name":"MTurk","cors":true},"mobileanalytics":{"name":"MobileAnalytics","cors":true},"opsworks":{"name":"OpsWorks","cors":true},"opsworkscm":{"name":"OpsWorksCM"},"organizations":{"name":"Organizations"},"pinpoint":{"name":"Pinpoint"},"polly":{"name":"Polly","cors":true},"rds":{"name":"RDS","versions":["2014-09-01*"],"cors":true},"redshift":{"name":"Redshift","cors":true},"rekognition":{"name":"Rekognition","cors":true},"resourcegroupstaggingapi":{"name":"ResourceGroupsTaggingAPI"},"route53":{"name":"Route53","cors":true},"route53domains":{"name":"Route53Domains","cors":true},"s3":{"name":"S3","dualstackAvailable":true,"cors":true},"s3control":{"name":"S3Control","dualstackAvailable":true,"xmlNoDefaultLists":true},"servicecatalog":{"name":"ServiceCatalog","cors":true},"ses":{"prefix":"email","name":"SES","cors":true},"shield":{"name":"Shield"},"simpledb":{"prefix":"sdb","name":"SimpleDB"},"sms":{"name":"SMS"},"snowball":{"name":"Snowball"},"sns":{"name":"SNS","cors":true},"sqs":{"name":"SQS","cors":true},"ssm":{"name":"SSM","cors":true},"storagegateway":{"name":"StorageGateway","cors":true},"stepfunctions":{"prefix":"states","name":"StepFunctions"},"sts":{"name":"STS","cors":true},"support":{"name":"Support"},"swf":{"name":"SWF"},"xray":{"name":"XRay","cors":true},"waf":{"name":"WAF","cors":true},"wafregional":{"prefix":"waf-regional","name":"WAFRegional"},"workdocs":{"name":"WorkDocs","cors":true},"workspaces":{"name":"WorkSpaces"},"codestar":{"name":"CodeStar"},"lexmodelbuildingservice":{"prefix":"lex-models","name":"LexModelBuildingService","cors":true},"marketplaceentitlementservice":{"prefix":"entitlement.marketplace","name":"MarketplaceEntitlementService"},"athena":{"name":"Athena"},"greengrass":{"name":"Greengrass"},"dax":{"name":"DAX"},"migrationhub":{"prefix":"AWSMigrationHub","name":"MigrationHub"},"cloudhsmv2":{"name":"CloudHSMV2"},"glue":{"name":"Glue"},"mobile":{"name":"Mobile"},"pricing":{"name":"Pricing","cors":true},"costexplorer":{"prefix":"ce","name":"CostExplorer","cors":true},"mediaconvert":{"name":"MediaConvert"},"medialive":{"name":"MediaLive"},"mediapackage":{"name":"MediaPackage"},"mediastore":{"name":"MediaStore"},"mediastoredata":{"prefix":"mediastore-data","name":"MediaStoreData","cors":true},"appsync":{"name":"AppSync"},"guardduty":{"name":"GuardDuty"},"mq":{"name":"MQ"},"comprehend":{"name":"Comprehend","cors":true},"iotjobsdataplane":{"prefix":"iot-jobs-data","name":"IoTJobsDataPlane"},"kinesisvideoarchivedmedia":{"prefix":"kinesis-video-archived-media","name":"KinesisVideoArchivedMedia","cors":true},"kinesisvideomedia":{"prefix":"kinesis-video-media","name":"KinesisVideoMedia","cors":true},"kinesisvideo":{"name":"KinesisVideo","cors":true},"sagemakerruntime":{"prefix":"runtime.sagemaker","name":"SageMakerRuntime"},"sagemaker":{"name":"SageMaker"},"translate":{"name":"Translate","cors":true},"resourcegroups":{"prefix":"resource-groups","name":"ResourceGroups","cors":true},"alexaforbusiness":{"name":"AlexaForBusiness"},"cloud9":{"name":"Cloud9"},"serverlessapplicationrepository":{"prefix":"serverlessrepo","name":"ServerlessApplicationRepository"},"servicediscovery":{"name":"ServiceDiscovery"},"workmail":{"name":"WorkMail"},"autoscalingplans":{"prefix":"autoscaling-plans","name":"AutoScalingPlans"},"transcribeservice":{"prefix":"transcribe","name":"TranscribeService"},"connect":{"name":"Connect","cors":true},"acmpca":{"prefix":"acm-pca","name":"ACMPCA"},"fms":{"name":"FMS"},"secretsmanager":{"name":"SecretsManager","cors":true},"iotanalytics":{"name":"IoTAnalytics","cors":true},"iot1clickdevicesservice":{"prefix":"iot1click-devices","name":"IoT1ClickDevicesService"},"iot1clickprojects":{"prefix":"iot1click-projects","name":"IoT1ClickProjects"},"pi":{"name":"PI"},"neptune":{"name":"Neptune"},"mediatailor":{"name":"MediaTailor"},"eks":{"name":"EKS"},"macie":{"name":"Macie"},"dlm":{"name":"DLM"},"signer":{"name":"Signer"},"chime":{"name":"Chime"},"pinpointemail":{"prefix":"pinpoint-email","name":"PinpointEmail"},"ram":{"name":"RAM"},"route53resolver":{"name":"Route53Resolver"},"pinpointsmsvoice":{"prefix":"sms-voice","name":"PinpointSMSVoice"},"quicksight":{"name":"QuickSight"},"rdsdataservice":{"prefix":"rds-data","name":"RDSDataService"},"amplify":{"name":"Amplify"},"datasync":{"name":"DataSync"},"robomaker":{"name":"RoboMaker"},"transfer":{"name":"Transfer"},"globalaccelerator":{"name":"GlobalAccelerator"},"comprehendmedical":{"name":"ComprehendMedical","cors":true},"kinesisanalyticsv2":{"name":"KinesisAnalyticsV2"},"mediaconnect":{"name":"MediaConnect"},"fsx":{"name":"FSx"},"securityhub":{"name":"SecurityHub"},"appmesh":{"name":"AppMesh","versions":["2018-10-01*"]},"licensemanager":{"prefix":"license-manager","name":"LicenseManager"},"kafka":{"name":"Kafka"},"apigatewaymanagementapi":{"name":"ApiGatewayManagementApi"},"apigatewayv2":{"name":"ApiGatewayV2"},"docdb":{"name":"DocDB"},"backup":{"name":"Backup"},"worklink":{"name":"WorkLink"},"textract":{"name":"Textract"},"managedblockchain":{"name":"ManagedBlockchain"},"mediapackagevod":{"prefix":"mediapackage-vod","name":"MediaPackageVod"},"groundstation":{"name":"GroundStation"},"iotthingsgraph":{"name":"IoTThingsGraph"},"iotevents":{"name":"IoTEvents"},"ioteventsdata":{"prefix":"iotevents-data","name":"IoTEventsData"},"personalize":{"name":"Personalize","cors":true},"personalizeevents":{"prefix":"personalize-events","name":"PersonalizeEvents","cors":true},"personalizeruntime":{"prefix":"personalize-runtime","name":"PersonalizeRuntime","cors":true},"applicationinsights":{"prefix":"application-insights","name":"ApplicationInsights"},"servicequotas":{"prefix":"service-quotas","name":"ServiceQuotas"},"ec2instanceconnect":{"prefix":"ec2-instance-connect","name":"EC2InstanceConnect"},"eventbridge":{"name":"EventBridge"},"lakeformation":{"name":"LakeFormation"},"forecastservice":{"prefix":"forecast","name":"ForecastService","cors":true},"forecastqueryservice":{"prefix":"forecastquery","name":"ForecastQueryService","cors":true},"qldb":{"name":"QLDB"},"qldbsession":{"prefix":"qldb-session","name":"QLDBSession"},"workmailmessageflow":{"name":"WorkMailMessageFlow"},"codestarnotifications":{"prefix":"codestar-notifications","name":"CodeStarNotifications"},"savingsplans":{"name":"SavingsPlans"},"sso":{"name":"SSO"},"ssooidc":{"prefix":"sso-oidc","name":"SSOOIDC"},"marketplacecatalog":{"prefix":"marketplace-catalog","name":"MarketplaceCatalog"},"dataexchange":{"name":"DataExchange"},"sesv2":{"name":"SESV2"},"migrationhubconfig":{"prefix":"migrationhub-config","name":"MigrationHubConfig"},"connectparticipant":{"name":"ConnectParticipant"},"appconfig":{"name":"AppConfig"},"iotsecuretunneling":{"name":"IoTSecureTunneling"},"wafv2":{"name":"WAFV2"},"elasticinference":{"prefix":"elastic-inference","name":"ElasticInference"},"imagebuilder":{"name":"Imagebuilder"},"schemas":{"name":"Schemas"},"accessanalyzer":{"name":"AccessAnalyzer"},"codegurureviewer":{"prefix":"codeguru-reviewer","name":"CodeGuruReviewer"},"codeguruprofiler":{"name":"CodeGuruProfiler"},"computeoptimizer":{"prefix":"compute-optimizer","name":"ComputeOptimizer"},"frauddetector":{"name":"FraudDetector"},"kendra":{"name":"Kendra"},"networkmanager":{"name":"NetworkManager"},"outposts":{"name":"Outposts"},"augmentedairuntime":{"prefix":"sagemaker-a2i-runtime","name":"AugmentedAIRuntime"},"ebs":{"name":"EBS"},"kinesisvideosignalingchannels":{"prefix":"kinesis-video-signaling","name":"KinesisVideoSignalingChannels","cors":true},"detective":{"name":"Detective"},"codestarconnections":{"prefix":"codestar-connections","name":"CodeStarconnections"}}

/***/ }),

/***/ 97:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = {
  items: [{
    name: 'Recurring Jobs',
    url: '/recurring',
    icon: 'icon-clock'
  }, {
    name: 'Presence Management',
    url: '/presence-management',
    icon: 'icon-map'
  }]
};

/***/ }),

/***/ 98:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Switch = exports.Sidebar = exports.Header = exports.Footer = exports.Callout = exports.Breadcrumb = exports.Aside = undefined;

var _Aside = __webpack_require__(332);

var _Aside2 = _interopRequireDefault(_Aside);

var _Breadcrumb = __webpack_require__(335);

var _Breadcrumb2 = _interopRequireDefault(_Breadcrumb);

var _Callout = __webpack_require__(338);

var _Callout2 = _interopRequireDefault(_Callout);

var _Footer = __webpack_require__(341);

var _Footer2 = _interopRequireDefault(_Footer);

var _Header = __webpack_require__(344);

var _Header2 = _interopRequireDefault(_Header);

var _Sidebar = __webpack_require__(348);

var _Sidebar2 = _interopRequireDefault(_Sidebar);

var _Switch = __webpack_require__(383);

var _Switch2 = _interopRequireDefault(_Switch);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.Aside = _Aside2.default;
exports.Breadcrumb = _Breadcrumb2.default;
exports.Callout = _Callout2.default;
exports.Footer = _Footer2.default;
exports.Header = _Header2.default;
exports.Sidebar = _Sidebar2.default;
exports.Switch = _Switch2.default;

/***/ })

},[242]);


// WEBPACK FOOTER //
// static/js/app.fd3500a52c859108b66c.js